// This file is generated by [oats][0] and should not be edited by hand.
//
// [0]: https://github.com/influxdata/oats

export interface Error {
  readonly code:
    | 'internal error'
    | 'not found'
    | 'conflict'
    | 'invalid'
    | 'unprocessable entity'
    | 'empty value'
    | 'unavailable'
    | 'forbidden'
    | 'too many requests'
    | 'unauthorized'
    | 'method not allowed'
    | 'request too large'
    | 'unsupported media type'
  readonly message?: string
  readonly op?: string
  readonly err?: string
}

export interface Routes {
  authorizations?: string
  buckets?: string
  dashboards?: string
  external?: {
    statusFeed?: string
  }
  variables?: string
  me?: string
  flags?: string
  orgs?: string
  query?: {
    self?: string
    ast?: string
    analyze?: string
    suggestions?: string
  }
  setup?: string
  signin?: string
  signout?: string
  sources?: string
  system?: {
    metrics?: string
    debug?: string
    health?: string
  }
  tasks?: string
  telegrafs?: string
  users?: string
  write?: string
}

export interface DBRPs {
  content?: DBRP[]
}

export interface DBRP {
  readonly id: string
  orgID: string
  bucketID: string
  database: string
  retention_policy: string
  default: boolean
  links?: Links
}

export interface Links {
  next?: Link
  self: Link
  prev?: Link
}

export type Link = string

export interface DBRPCreate {
  orgID?: string
  org?: string
  bucketID: string
  database: string
  retention_policy: string
  default?: boolean
}

export interface DBRPGet {
  content?: DBRP
}

export interface DBRPUpdate {
  retention_policy?: string
  default?: boolean
}

export interface TelegrafPlugins {
  version?: string
  os?: string
  plugins?: TelegrafPlugin[]
}

export interface TelegrafPlugin {
  type?: string
  name?: string
  description?: string
  config?: string
}

export interface Telegrafs {
  configurations?: Telegraf[]
}

export type Telegraf = TelegrafRequest & {
  readonly id?: string
  readonly links?: {
    self?: Link
    labels?: Link
    members?: Link
    owners?: Link
  }
  readonly labels?: Labels
}

export interface TelegrafRequest {
  name?: string
  description?: string
  metadata?: {
    buckets?: string[]
  }
  config?: string
  orgID?: string
}

export type Labels = Label[]

export interface Label {
  readonly id?: string
  readonly orgID?: string
  name?: string
  properties?: any
}

export interface TelegrafPluginRequest {
  name?: string
  description?: string
  plugins?: Array<{
    type?: string
    name?: string
    alias?: string
    description?: string
    config?: string
  }>
  metadata?: {
    buckets?: string[]
  }
  config?: string
  orgID?: string
}

export interface LabelsResponse {
  labels?: Labels
  links?: Links
}

export interface LabelMapping {
  labelID?: string
}

export interface LabelResponse {
  label?: Label
  links?: Links
}

export interface ResourceMembers {
  links?: {
    self?: string
  }
  users?: ResourceMember[]
}

export type ResourceMember = UserResponse & {
  role?: 'member'
}

export interface UserResponse {
  readonly id?: string
  oauthID?: string
  name: string
  status?: 'active' | 'inactive'
  readonly links?: {
    self?: string
  }
}

export interface AddResourceMemberRequestBody {
  id: string
  name?: string
}

export interface ResourceOwners {
  links?: {
    self?: string
  }
  users?: ResourceOwner[]
}

export type ResourceOwner = UserResponse & {
  role?: 'owner'
}

export interface LineProtocolError {
  readonly code:
    | 'internal error'
    | 'not found'
    | 'conflict'
    | 'invalid'
    | 'empty value'
    | 'unavailable'
  readonly message?: string
  readonly op?: string
  readonly err?: string
  readonly line?: number
}

export interface LineProtocolLengthError {
  readonly code: 'invalid'
  readonly message: string
}

export interface DeletePredicateRequest {
  start: string
  stop: string
  predicate?: string
}

export interface LabelCreateRequest {
  orgID: string
  name: string
  properties?: any
}

export interface LabelUpdate {
  name?: string
  properties?: any
}

export type Dashboard = CreateDashboardRequest & {
  links?: {
    self?: Link
    cells?: Link
    members?: Link
    owners?: Link
    labels?: Link
    org?: Link
  }
  readonly id?: string
  meta?: {
    createdAt?: string
    updatedAt?: string
  }
  cells?: Cells
  labels?: Labels
}

export interface CreateDashboardRequest {
  orgID: string
  name: string
  description?: string
}

export type Cells = Cell[]

export interface Cell {
  id?: string
  links?: {
    self?: string
    view?: string
  }
  x?: number
  y?: number
  w?: number
  h?: number
  viewID?: string
}

export type DashboardWithViewProperties = CreateDashboardRequest & {
  links?: {
    self?: Link
    cells?: Link
    members?: Link
    owners?: Link
    labels?: Link
    org?: Link
  }
  readonly id?: string
  meta?: {
    createdAt?: string
    updatedAt?: string
  }
  cells?: CellsWithViewProperties
  labels?: Labels
}

export type CellsWithViewProperties = CellWithViewProperties[]

export type CellWithViewProperties = Cell & {
  name?: string
  properties?: ViewProperties
}

export type ViewProperties =
  | LinePlusSingleStatProperties
  | XYViewProperties
  | SingleStatViewProperties
  | HistogramViewProperties
  | GaugeViewProperties
  | TableViewProperties
  | SimpleTableViewProperties
  | MarkdownViewProperties
  | CheckViewProperties
  | ScatterViewProperties
  | HeatmapViewProperties
  | MosaicViewProperties
  | BandViewProperties
  | GeoViewProperties

export interface LinePlusSingleStatProperties {
  timeFormat?: string
  type: 'line-plus-single-stat'
  queries: DashboardQuery[]
  colors: DashboardColor[]
  shape: 'chronograf-v2'
  note: string
  showNoteWhenEmpty: boolean
  axes: Axes
  staticLegend?: StaticLegend
  xColumn?: string
  generateXAxisTicks?: string[]
  xTotalTicks?: number
  xTickStart?: number
  xTickStep?: number
  yColumn?: string
  generateYAxisTicks?: string[]
  yTotalTicks?: number
  yTickStart?: number
  yTickStep?: number
  shadeBelow?: boolean
  hoverDimension?: 'auto' | 'x' | 'y' | 'xy'
  position: 'overlaid' | 'stacked'
  prefix: string
  suffix: string
  decimalPlaces: DecimalPlaces
  legendColorizeRows?: boolean
  legendHide?: boolean
  legendOpacity?: number
  legendOrientationThreshold?: number
}

export interface DashboardQuery {
  text?: string
  editMode?: QueryEditMode
  name?: string
  builderConfig?: BuilderConfig
}

export type QueryEditMode = 'builder' | 'advanced'

export interface BuilderConfig {
  buckets?: string[]
  tags?: BuilderTagsType[]
  functions?: BuilderFunctionsType[]
  aggregateWindow?: {
    period?: string
    fillValues?: boolean
  }
}

export interface BuilderTagsType {
  key?: string
  values?: string[]
  aggregateFunctionType?: BuilderAggregateFunctionType
}

export type BuilderAggregateFunctionType = 'filter' | 'group'

export interface BuilderFunctionsType {
  name?: string
}

export interface DashboardColor {
  id: string
  type: 'min' | 'max' | 'threshold' | 'scale' | 'text' | 'background'
  hex: string
  name: string
  value: number
}

export interface Axes {
  x: Axis
  y: Axis
}

export interface Axis {
  bounds?: string[]
  label?: string
  prefix?: string
  suffix?: string
  base?: '' | '2' | '10'
  scale?: AxisScale
}

export type AxisScale = 'log' | 'linear'

export interface StaticLegend {
  colorizeRows?: boolean
  heightRatio?: number
  show?: boolean
  opacity?: number
  orientationThreshold?: number
  valueAxis?: string
  widthRatio?: number
}

export interface DecimalPlaces {
  isEnforced?: boolean
  digits?: number
}

export interface XYViewProperties {
  timeFormat?: string
  type: 'xy'
  queries: DashboardQuery[]
  colors: DashboardColor[]
  colorMapping?: ColorMapping
  shape: 'chronograf-v2'
  note: string
  showNoteWhenEmpty: boolean
  axes: Axes
  staticLegend?: StaticLegend
  xColumn?: string
  generateXAxisTicks?: string[]
  xTotalTicks?: number
  xTickStart?: number
  xTickStep?: number
  yColumn?: string
  generateYAxisTicks?: string[]
  yTotalTicks?: number
  yTickStart?: number
  yTickStep?: number
  shadeBelow?: boolean
  hoverDimension?: 'auto' | 'x' | 'y' | 'xy'
  position: 'overlaid' | 'stacked'
  geom: XYGeom
  legendColorizeRows?: boolean
  legendHide?: boolean
  legendOpacity?: number
  legendOrientationThreshold?: number
}

export type ColorMapping = any

export type XYGeom =
  | 'line'
  | 'step'
  | 'stacked'
  | 'bar'
  | 'monotoneX'
  | 'stepBefore'
  | 'stepAfter'

export interface SingleStatViewProperties {
  type: 'single-stat'
  queries: DashboardQuery[]
  colors: DashboardColor[]
  shape: 'chronograf-v2'
  note: string
  showNoteWhenEmpty: boolean
  prefix: string
  tickPrefix: string
  suffix: string
  tickSuffix: string
  staticLegend?: StaticLegend
  decimalPlaces: DecimalPlaces
}

export interface HistogramViewProperties {
  type: 'histogram'
  queries: DashboardQuery[]
  colors: DashboardColor[]
  shape: 'chronograf-v2'
  note: string
  showNoteWhenEmpty: boolean
  xColumn: string
  fillColumns: string[]
  xDomain: number[]
  xAxisLabel: string
  position: 'overlaid' | 'stacked'
  binCount: number
  legendColorizeRows?: boolean
  legendHide?: boolean
  legendOpacity?: number
  legendOrientationThreshold?: number
}

export interface GaugeViewProperties {
  type: 'gauge'
  queries: DashboardQuery[]
  colors: DashboardColor[]
  shape: 'chronograf-v2'
  note: string
  showNoteWhenEmpty: boolean
  prefix: string
  tickPrefix: string
  suffix: string
  tickSuffix: string
  decimalPlaces: DecimalPlaces
}

export interface TableViewProperties {
  type: 'table'
  queries: DashboardQuery[]
  colors: DashboardColor[]
  shape: 'chronograf-v2'
  note: string
  showNoteWhenEmpty: boolean
  tableOptions: {
    verticalTimeAxis?: boolean
    sortBy?: RenamableField
    wrapping?: 'truncate' | 'wrap' | 'single-line'
    fixFirstColumn?: boolean
  }
  fieldOptions: RenamableField[]
  timeFormat: string
  decimalPlaces: DecimalPlaces
}

export interface RenamableField {
  readonly internalName?: string
  displayName?: string
  visible?: boolean
}

export interface SimpleTableViewProperties {
  type: 'simple-table'
  showAll: boolean
  queries: DashboardQuery[]
  shape: 'chronograf-v2'
  note: string
  showNoteWhenEmpty: boolean
}

export interface MarkdownViewProperties {
  type: 'markdown'
  shape: 'chronograf-v2'
  note: string
}

export interface CheckViewProperties {
  type: 'check'
  shape: 'chronograf-v2'
  checkID: string
  check?: Check
  queries: DashboardQuery[]
  colors: DashboardColor[]
  legendColorizeRows?: boolean
  legendHide?: boolean
  legendOpacity?: number
  legendOrientationThreshold?: number
}

export type Check = CheckDiscriminator

export type CheckDiscriminator =
  | (DeadmanCheck & {type: string})
  | (ThresholdCheck & {type: string})
  | (CustomCheck & {type: string})

export type DeadmanCheck = CheckBase & {
  type: 'deadman'
  timeSince?: string
  staleTime?: string
  reportZero?: boolean
  level?: CheckStatusLevel
  every?: string
  offset?: string
  tags?: Array<{
    key?: string
    value?: string
  }>
  statusMessageTemplate?: string
}

export interface CheckBase {
  readonly id?: string
  name: string
  orgID: string
  taskID?: string
  readonly ownerID?: string
  readonly createdAt?: string
  readonly updatedAt?: string
  query: DashboardQuery
  status?: TaskStatusType
  description?: string
  readonly latestCompleted?: string
  readonly lastRunStatus?: 'failed' | 'success' | 'canceled'
  readonly lastRunError?: string
  labels?: Labels
  readonly links?: {
    self?: Link
    labels?: Link
    members?: Link
    owners?: Link
    query?: Link
  }
}

export type TaskStatusType = 'active' | 'inactive'

export type CheckStatusLevel = 'UNKNOWN' | 'OK' | 'INFO' | 'CRIT' | 'WARN'

export type ThresholdCheck = CheckBase & {
  type: 'threshold'
  thresholds?: Threshold[]
  every?: string
  offset?: string
  tags?: Array<{
    key?: string
    value?: string
  }>
  statusMessageTemplate?: string
}

export type Threshold =
  | (GreaterThreshold & {type: string})
  | (LesserThreshold & {type: string})
  | (RangeThreshold & {type: string})

export type GreaterThreshold = ThresholdBase & {
  type: 'greater'
  value: number
}

export interface ThresholdBase {
  level?: CheckStatusLevel
  allValues?: boolean
}

export type LesserThreshold = ThresholdBase & {
  type: 'lesser'
  value: number
}

export type RangeThreshold = ThresholdBase & {
  type: 'range'
  min: number
  max: number
  within: boolean
}

export type CustomCheck = CheckBase & {
  type: 'custom'
}

export interface ScatterViewProperties {
  timeFormat?: string
  type: 'scatter'
  queries: DashboardQuery[]
  colors: string[]
  shape: 'chronograf-v2'
  note: string
  showNoteWhenEmpty: boolean
  xColumn: string
  generateXAxisTicks?: string[]
  xTotalTicks?: number
  xTickStart?: number
  xTickStep?: number
  yColumn: string
  generateYAxisTicks?: string[]
  yTotalTicks?: number
  yTickStart?: number
  yTickStep?: number
  fillColumns: string[]
  symbolColumns: string[]
  xDomain: number[]
  yDomain: number[]
  xAxisLabel: string
  yAxisLabel: string
  xPrefix: string
  xSuffix: string
  yPrefix: string
  ySuffix: string
  legendColorizeRows?: boolean
  legendHide?: boolean
  legendOpacity?: number
  legendOrientationThreshold?: number
}

export interface HeatmapViewProperties {
  timeFormat?: string
  type: 'heatmap'
  queries: DashboardQuery[]
  colors: string[]
  shape: 'chronograf-v2'
  note: string
  showNoteWhenEmpty: boolean
  xColumn: string
  generateXAxisTicks?: string[]
  xTotalTicks?: number
  xTickStart?: number
  xTickStep?: number
  yColumn: string
  generateYAxisTicks?: string[]
  yTotalTicks?: number
  yTickStart?: number
  yTickStep?: number
  xDomain: number[]
  yDomain: number[]
  xAxisLabel: string
  yAxisLabel: string
  xPrefix: string
  xSuffix: string
  yPrefix: string
  ySuffix: string
  binSize: number
  legendColorizeRows?: boolean
  legendHide?: boolean
  legendOpacity?: number
  legendOrientationThreshold?: number
}

export interface MosaicViewProperties {
  timeFormat?: string
  type: 'mosaic'
  queries: DashboardQuery[]
  colors: string[]
  shape: 'chronograf-v2'
  note: string
  showNoteWhenEmpty: boolean
  xColumn: string
  generateXAxisTicks?: string[]
  xTotalTicks?: number
  xTickStart?: number
  xTickStep?: number
  yLabelColumnSeparator?: string
  yLabelColumns?: string[]
  ySeriesColumns: string[]
  fillColumns: string[]
  xDomain: number[]
  yDomain: number[]
  xAxisLabel: string
  yAxisLabel: string
  xPrefix: string
  xSuffix: string
  yPrefix: string
  ySuffix: string
  hoverDimension?: 'auto' | 'x' | 'y' | 'xy'
  legendColorizeRows?: boolean
  legendHide?: boolean
  legendOpacity?: number
  legendOrientationThreshold?: number
}

export interface BandViewProperties {
  timeFormat?: string
  type: 'band'
  queries: DashboardQuery[]
  colors: DashboardColor[]
  shape: 'chronograf-v2'
  note: string
  showNoteWhenEmpty: boolean
  axes: Axes
  staticLegend?: StaticLegend
  xColumn?: string
  generateXAxisTicks?: string[]
  xTotalTicks?: number
  xTickStart?: number
  xTickStep?: number
  yColumn?: string
  generateYAxisTicks?: string[]
  yTotalTicks?: number
  yTickStart?: number
  yTickStep?: number
  upperColumn?: string
  mainColumn?: string
  lowerColumn?: string
  hoverDimension?: 'auto' | 'x' | 'y' | 'xy'
  geom: XYGeom
  legendColorizeRows?: boolean
  legendHide?: boolean
  legendOpacity?: number
  legendOrientationThreshold?: number
}

export interface GeoViewProperties {
  type: 'geo'
  queries: DashboardQuery[]
  shape: 'chronograf-v2'
  center: {
    lat: number
    lon: number
  }
  zoom: number
  allowPanAndZoom: boolean
  detectCoordinateFields: boolean
  useS2CellID?: boolean
  s2Column?: string
  latLonColumns?: LatLonColumns
  mapStyle?: string
  note: string
  showNoteWhenEmpty: boolean
  colors?: DashboardColor[]
  layers: GeoViewLayer[]
}

export interface LatLonColumns {
  lat: LatLonColumn
  lon: LatLonColumn
}

export interface LatLonColumn {
  key: string
  column: string
}

export type GeoViewLayer =
  | GeoCircleViewLayer
  | GeoHeatMapViewLayer
  | GeoPointMapViewLayer
  | GeoTrackMapViewLayer

export type GeoCircleViewLayer = GeoViewLayerProperties & {
  radiusField: string
  radiusDimension: Axis
  colorField: string
  colorDimension: Axis
  colors: DashboardColor[]
  radius?: number
  interpolateColors?: boolean
}

export interface GeoViewLayerProperties {
  type: 'heatmap' | 'circleMap' | 'pointMap' | 'trackMap'
}

export type GeoHeatMapViewLayer = GeoViewLayerProperties & {
  intensityField: string
  intensityDimension: Axis
  radius: number
  blur: number
  colors: DashboardColor[]
}

export type GeoPointMapViewLayer = GeoViewLayerProperties & {
  colorField: string
  colorDimension: Axis
  colors: DashboardColor[]
  isClustered?: boolean
  tooltipColumns?: string[]
}

export type GeoTrackMapViewLayer = GeoViewLayerProperties & any

export interface CreateCell {
  name?: string
  x?: number
  y?: number
  w?: number
  h?: number
  usingView?: string
}

export interface CellUpdate {
  x?: number
  y?: number
  w?: number
  h?: number
}

export interface View {
  readonly links?: {
    self?: string
  }
  readonly id?: string
  name: string
  properties: ViewProperties
}

export interface LanguageRequest {
  query: string
}

export interface ASTResponse {
  ast?: Package
}

export interface Package {
  type?: NodeType
  path?: string
  package?: string
  files?: File[]
}

export type NodeType = string

export interface File {
  type?: NodeType
  name?: string
  package?: PackageClause
  imports?: ImportDeclaration[]
  body?: Statement[]
}

export interface PackageClause {
  type?: NodeType
  name?: Identifier
}

export interface Identifier {
  type?: NodeType
  name?: string
}

export interface ImportDeclaration {
  type?: NodeType
  as?: Identifier
  path?: StringLiteral
}

export interface StringLiteral {
  type?: NodeType
  value?: string
}

export type Statement =
  | BadStatement
  | VariableAssignment
  | MemberAssignment
  | ExpressionStatement
  | ReturnStatement
  | OptionStatement
  | BuiltinStatement
  | TestStatement

export interface BadStatement {
  type?: NodeType
  text?: string
}

export interface VariableAssignment {
  type?: NodeType
  id?: Identifier
  init?: Expression
}

export type Expression =
  | ArrayExpression
  | DictExpression
  | FunctionExpression
  | BinaryExpression
  | CallExpression
  | ConditionalExpression
  | LogicalExpression
  | MemberExpression
  | IndexExpression
  | ObjectExpression
  | ParenExpression
  | PipeExpression
  | UnaryExpression
  | BooleanLiteral
  | DateTimeLiteral
  | DurationLiteral
  | FloatLiteral
  | IntegerLiteral
  | PipeLiteral
  | RegexpLiteral
  | StringLiteral
  | UnsignedIntegerLiteral
  | Identifier

export interface ArrayExpression {
  type?: NodeType
  elements?: Expression[]
}

export interface DictExpression {
  type?: NodeType
  elements?: DictItem[]
}

export interface DictItem {
  type?: NodeType
  key?: Expression
  val?: Expression
}

export interface FunctionExpression {
  type?: NodeType
  params?: Property[]
  body?: Node
}

export interface Property {
  type?: NodeType
  key?: PropertyKey
  value?: Expression
}

export type PropertyKey = Identifier | StringLiteral

export type Node = Expression | Block

export interface Block {
  type?: NodeType
  body?: Statement[]
}

export interface BinaryExpression {
  type?: NodeType
  operator?: string
  left?: Expression
  right?: Expression
}

export interface CallExpression {
  type?: NodeType
  callee?: Expression
  arguments?: Expression[]
}

export interface ConditionalExpression {
  type?: NodeType
  test?: Expression
  alternate?: Expression
  consequent?: Expression
}

export interface LogicalExpression {
  type?: NodeType
  operator?: string
  left?: Expression
  right?: Expression
}

export interface MemberExpression {
  type?: NodeType
  object?: Expression
  property?: PropertyKey
}

export interface IndexExpression {
  type?: NodeType
  array?: Expression
  index?: Expression
}

export interface ObjectExpression {
  type?: NodeType
  properties?: Property[]
}

export interface ParenExpression {
  type?: NodeType
  expression?: Expression
}

export interface PipeExpression {
  type?: NodeType
  argument?: Expression
  call?: CallExpression
}

export interface UnaryExpression {
  type?: NodeType
  operator?: string
  argument?: Expression
}

export interface BooleanLiteral {
  type?: NodeType
  value?: boolean
}

export interface DateTimeLiteral {
  type?: NodeType
  value?: string
}

export interface DurationLiteral {
  type?: NodeType
  values?: Duration[]
}

export interface Duration {
  type?: NodeType
  magnitude?: number
  unit?: string
}

export interface FloatLiteral {
  type?: NodeType
  value?: number
}

export interface IntegerLiteral {
  type?: NodeType
  value?: string
}

export interface PipeLiteral {
  type?: NodeType
}

export interface RegexpLiteral {
  type?: NodeType
  value?: string
}

export interface UnsignedIntegerLiteral {
  type?: NodeType
  value?: string
}

export interface MemberAssignment {
  type?: NodeType
  member?: MemberExpression
  init?: Expression
}

export interface ExpressionStatement {
  type?: NodeType
  expression?: Expression
}

export interface ReturnStatement {
  type?: NodeType
  argument?: Expression
}

export interface OptionStatement {
  type?: NodeType
  assignment?: VariableAssignment | MemberAssignment
}

export interface BuiltinStatement {
  type?: NodeType
  id?: Identifier
}

export interface TestStatement {
  type?: NodeType
  assignment?: VariableAssignment
}

export interface FluxSuggestions {
  funcs?: FluxSuggestion[]
}

export interface FluxSuggestion {
  name?: string
  params?: any
}

export interface Query {
  extern?: File
  query: string
  type?: 'flux'
  params?: any
  dialect?: Dialect
  now?: string
}

export interface Dialect {
  header?: boolean
  delimiter?: string
  annotations?: Array<'group' | 'datatype' | 'default'>
  commentPrefix?: string
  dateTimeFormat?: 'RFC3339' | 'RFC3339Nano'
}

export interface AnalyzeQueryResponse {
  errors?: Array<{
    line?: number
    column?: number
    character?: number
    message?: string
  }>
}

export interface Buckets {
  readonly links?: Links
  buckets?: Bucket[]
}

export interface Bucket {
  readonly links?: {
    labels?: Link
    members?: Link
    org?: Link
    owners?: Link
    self?: Link
    write?: Link
  }
  readonly id?: string
  readonly type?: 'user' | 'system'
  name: string
  description?: string
  orgID?: string
  rp?: string
  schemaType?: SchemaType
  readonly createdAt?: string
  readonly updatedAt?: string
  retentionRules: RetentionRules
  labels?: Labels
}

export type SchemaType = 'implicit' | 'explicit'

export type RetentionRules = RetentionRule[]

export interface RetentionRule {
  type: 'expire'
  everySeconds: number
  shardGroupDurationSeconds?: number
}

export interface PostBucketRequest {
  orgID: string
  name: string
  description?: string
  rp?: string
  retentionRules: RetentionRules
  schemaType?: SchemaType
}

export interface PatchBucketRequest {
  name?: string
  description?: string
  retentionRules?: PatchRetentionRules
}

export type PatchRetentionRules = PatchRetentionRule[]

export interface PatchRetentionRule {
  type: 'expire'
  everySeconds?: number
  shardGroupDurationSeconds?: number
}

export interface Organizations {
  links?: Links
  orgs?: Organization[]
}

export interface Organization {
  readonly links?: {
    self?: Link
    members?: Link
    owners?: Link
    labels?: Link
    secrets?: Link
    buckets?: Link
    tasks?: Link
    dashboards?: Link
  }
  readonly id?: string
  name: string
  description?: string
  readonly createdAt?: string
  readonly updatedAt?: string
  status?: 'active' | 'inactive'
}

export interface PostOrganizationRequest {
  name: string
  description?: string
}

export interface PatchOrganizationRequest {
  name?: string
  description?: string
}

export type SecretKeysResponse = SecretKeys & {
  readonly links?: {
    self?: string
    org?: string
  }
}

export interface SecretKeys {
  secrets?: string[]
}

export type Secrets = any

export interface Stack {
  id?: string
  orgID?: string
  readonly createdAt?: string
  events?: Array<{
    eventType?: string
    name?: string
    description?: string
    sources?: string[]
    resources?: Array<{
      apiVersion?: string
      resourceID?: string
      kind?: TemplateKind
      templateMetaName?: string
      associations?: Array<{
        kind?: TemplateKind
        metaName?: string
      }>
      links?: {
        self?: string
      }
    }>
    urls?: string[]
    readonly updatedAt?: string
  }>
}

export type TemplateKind =
  | 'Bucket'
  | 'Check'
  | 'CheckDeadman'
  | 'CheckThreshold'
  | 'Dashboard'
  | 'Label'
  | 'NotificationEndpoint'
  | 'NotificationEndpointHTTP'
  | 'NotificationEndpointPagerDuty'
  | 'NotificationEndpointSlack'
  | 'NotificationRule'
  | 'Task'
  | 'Telegraf'
  | 'Variable'

export interface TemplateApply {
  dryRun?: boolean
  orgID?: string
  stackID?: string
  template?: {
    contentType?: string
    sources?: string[]
    contents?: Template
  }
  templates?: Array<{
    contentType?: string
    sources?: string[]
    contents?: Template
  }>
  envRefs?: any
  secrets?: any
  remotes?: Array<{
    url: string
    contentType?: string
  }>
  actions?: Array<
    | {
        action?: 'skipKind'
        properties?: {
          kind: TemplateKind
        }
      }
    | {
        action?: 'skipResource'
        properties?: {
          kind: TemplateKind
          resourceTemplateName: string
        }
      }
  >
}

export type Template = Array<{
  apiVersion?: string
  kind?: TemplateKind
  meta?: {
    name?: string
  }
  spec?: any
}>

export interface TemplateSummary {
  sources?: string[]
  stackID?: string
  summary?: {
    buckets?: Array<{
      id?: string
      orgID?: string
      kind?: TemplateKind
      templateMetaName?: string
      name?: string
      description?: string
      retentionPeriod?: number
      labelAssociations?: TemplateSummaryLabel[]
      envReferences?: TemplateEnvReferences
    }>
    checks?: Array<
      CheckDiscriminator & {
        kind?: TemplateKind
        templateMetaName?: string
        labelAssociations?: TemplateSummaryLabel[]
        envReferences?: TemplateEnvReferences
      }
    >
    dashboards?: Array<{
      id?: string
      orgID?: string
      kind?: TemplateKind
      templateMetaName?: string
      name?: string
      description?: string
      labelAssociations?: TemplateSummaryLabel[]
      charts?: TemplateChart[]
      envReferences?: TemplateEnvReferences
    }>
    labels?: TemplateSummaryLabel[]
    labelMappings?: Array<{
      status?: string
      resourceTemplateMetaName?: string
      resourceName?: string
      resourceID?: string
      resourceType?: string
      labelTemplateMetaName?: string
      labelName?: string
      labelID?: string
    }>
    missingEnvRefs?: string[]
    missingSecrets?: string[]
    notificationEndpoints?: Array<
      NotificationEndpointDiscriminator & {
        kind?: TemplateKind
        templateMetaName?: string
        labelAssociations?: TemplateSummaryLabel[]
        envReferences?: TemplateEnvReferences
      }
    >
    notificationRules?: Array<{
      kind?: TemplateKind
      templateMetaName?: string
      name?: string
      description?: string
      endpointTemplateMetaName?: string
      endpointID?: string
      endpointType?: string
      every?: string
      offset?: string
      messageTemplate?: string
      status?: string
      statusRules?: Array<{
        currentLevel?: string
        previousLevel?: string
      }>
      tagRules?: Array<{
        key?: string
        value?: string
        operator?: string
      }>
      labelAssociations?: TemplateSummaryLabel[]
      envReferences?: TemplateEnvReferences
    }>
    tasks?: Array<{
      kind?: TemplateKind
      templateMetaName?: string
      id?: string
      name?: string
      cron?: string
      description?: string
      every?: string
      offset?: string
      query?: string
      status?: string
      envReferences?: TemplateEnvReferences
    }>
    telegrafConfigs?: Array<
      TelegrafRequest & {
        kind?: TemplateKind
        templateMetaName?: string
        labelAssociations?: TemplateSummaryLabel[]
        envReferences?: TemplateEnvReferences
      }
    >
    variables?: Array<{
      kind?: TemplateKind
      templateMetaName?: string
      id?: string
      orgID?: string
      name?: string
      description?: string
      arguments?: VariableProperties
      labelAssociations?: TemplateSummaryLabel[]
      envReferences?: TemplateEnvReferences
    }>
  }
  diff?: {
    buckets?: Array<{
      kind?: TemplateKind
      stateStatus?: string
      id?: string
      templateMetaName?: string
      new?: {
        name?: string
        description?: string
        retentionRules?: RetentionRules
      }
      old?: {
        name?: string
        description?: string
        retentionRules?: RetentionRules
      }
    }>
    checks?: Array<{
      kind?: TemplateKind
      stateStatus?: string
      id?: string
      templateMetaName?: string
      new?: CheckDiscriminator
      old?: CheckDiscriminator
    }>
    dashboards?: Array<{
      stateStatus?: string
      id?: string
      kind?: TemplateKind
      templateMetaName?: string
      new?: {
        name?: string
        description?: string
        charts?: TemplateChart[]
      }
      old?: {
        name?: string
        description?: string
        charts?: TemplateChart[]
      }
    }>
    labels?: Array<{
      stateStatus?: string
      kind?: TemplateKind
      id?: string
      templateMetaName?: string
      new?: {
        name?: string
        color?: string
        description?: string
      }
      old?: {
        name?: string
        color?: string
        description?: string
      }
    }>
    labelMappings?: Array<{
      status?: string
      resourceType?: string
      resourceID?: string
      resourceTemplateMetaName?: string
      resourceName?: string
      labelID?: string
      labelTemplateMetaName?: string
      labelName?: string
    }>
    notificationEndpoints?: Array<{
      kind?: TemplateKind
      stateStatus?: string
      id?: string
      templateMetaName?: string
      new?: NotificationEndpointDiscriminator
      old?: NotificationEndpointDiscriminator
    }>
    notificationRules?: Array<{
      kind?: TemplateKind
      stateStatus?: string
      id?: string
      templateMetaName?: string
      new?: {
        name?: string
        description?: string
        endpointName?: string
        endpointID?: string
        endpointType?: string
        every?: string
        offset?: string
        messageTemplate?: string
        status?: string
        statusRules?: Array<{
          currentLevel?: string
          previousLevel?: string
        }>
        tagRules?: Array<{
          key?: string
          value?: string
          operator?: string
        }>
      }
      old?: {
        name?: string
        description?: string
        endpointName?: string
        endpointID?: string
        endpointType?: string
        every?: string
        offset?: string
        messageTemplate?: string
        status?: string
        statusRules?: Array<{
          currentLevel?: string
          previousLevel?: string
        }>
        tagRules?: Array<{
          key?: string
          value?: string
          operator?: string
        }>
      }
    }>
    tasks?: Array<{
      kind?: TemplateKind
      stateStatus?: string
      id?: string
      templateMetaName?: string
      new?: {
        name?: string
        cron?: string
        description?: string
        every?: string
        offset?: string
        query?: string
        status?: string
      }
      old?: {
        name?: string
        cron?: string
        description?: string
        every?: string
        offset?: string
        query?: string
        status?: string
      }
    }>
    telegrafConfigs?: Array<{
      kind?: TemplateKind
      stateStatus?: string
      id?: string
      templateMetaName?: string
      new?: TelegrafRequest
      old?: TelegrafRequest
    }>
    variables?: Array<{
      kind?: TemplateKind
      stateStatus?: string
      id?: string
      templateMetaName?: string
      new?: {
        name?: string
        description?: string
        args?: VariableProperties
      }
      old?: {
        name?: string
        description?: string
        args?: VariableProperties
      }
    }>
  }
  errors?: Array<{
    kind?: TemplateKind
    reason?: string
    fields?: string[]
    indexes?: number[]
  }>
}

export interface TemplateSummaryLabel {
  id?: string
  orgID?: string
  kind?: TemplateKind
  templateMetaName?: string
  name?: string
  properties?: {
    color?: string
    description?: string
  }
  envReferences?: TemplateEnvReferences
}

export type TemplateEnvReferences = Array<{
  resourceField: string
  envRefKey: string
  value?: string | number | number | boolean
  defaultValue?: string | number | number | boolean
}>

export interface TemplateChart {
  xPos?: number
  yPos?: number
  height?: number
  width?: number
  properties?: ViewProperties
}

export type NotificationEndpointDiscriminator =
  | (SlackNotificationEndpoint & {type: string})
  | (PagerDutyNotificationEndpoint & {type: string})
  | (HTTPNotificationEndpoint & {type: string})
  | (TelegramNotificationEndpoint & {type: string})

export type SlackNotificationEndpoint = NotificationEndpointBase & {
  url?: string
  token?: string
}

export interface NotificationEndpointBase {
  id?: string
  orgID?: string
  userID?: string
  readonly createdAt?: string
  readonly updatedAt?: string
  description?: string
  name: string
  status?: 'active' | 'inactive'
  labels?: Labels
  readonly links?: {
    self?: Link
    labels?: Link
    members?: Link
    owners?: Link
  }
  type: NotificationEndpointType
}

export type NotificationEndpointType =
  | 'slack'
  | 'pagerduty'
  | 'http'
  | 'telegram'

export type PagerDutyNotificationEndpoint = NotificationEndpointBase & {
  clientURL?: string
  routingKey: string
}

export type HTTPNotificationEndpoint = NotificationEndpointBase & {
  url: string
  username?: string
  password?: string
  token?: string
  method: 'POST' | 'GET' | 'PUT'
  authMethod: 'none' | 'basic' | 'bearer'
  contentTemplate?: string
  headers?: any
}

export type TelegramNotificationEndpoint = NotificationEndpointBase & {
  token: string
  channel: string
}

export type VariableProperties =
  | QueryVariableProperties
  | ConstantVariableProperties
  | MapVariableProperties

export interface QueryVariableProperties {
  type?: 'query'
  values?: {
    query?: string
    language?: string
  }
}

export interface ConstantVariableProperties {
  type?: 'constant'
  values?: string[]
}

export interface MapVariableProperties {
  type?: 'map'
  values?: any
}

export interface TemplateExportByID {
  stackID?: string
  orgIDs?: Array<{
    orgID?: string
    resourceFilters?: {
      byLabel?: string[]
      byResourceKind?: TemplateKind[]
    }
  }>
  resources?: Array<{
    id: string
    kind: TemplateKind
    name?: string
  }>
}

export interface TemplateExportByName {
  stackID?: string
  orgIDs?: Array<{
    orgID?: string
    resourceFilters?: {
      byLabel?: string[]
      byResourceKind?: TemplateKind[]
    }
  }>
  resources?: Array<{
    kind: TemplateKind
    name: string
  }>
}

export interface Runs {
  links?: Links
  runs?: Run[]
}

export interface Run {
  readonly id?: string
  readonly taskID?: string
  readonly status?: 'scheduled' | 'started' | 'failed' | 'success' | 'canceled'
  scheduledFor?: string
  readonly log?: LogEvent[]
  readonly flux?: string
  readonly startedAt?: string
  readonly finishedAt?: string
  readonly requestedAt?: string
  readonly links?: {
    self?: string
    task?: string
    retry?: string
  }
}

export interface LogEvent {
  readonly time?: string
  readonly message?: string
  readonly runID?: string
}

export interface RunManually {
  scheduledFor?: string
}

export interface Logs {
  readonly events?: LogEvent[]
}

export type Flags = any

export interface PasswordResetBody {
  password: string
}

export interface Checks {
  checks?: Check[]
  links?: Links
}

export type PostCheck = CheckDiscriminator

export interface CheckPatch {
  name?: string
  description?: string
  status?: 'active' | 'inactive'
}

export interface NotificationRules {
  notificationRules?: NotificationRule[]
  links?: Links
}

export type NotificationRule = NotificationRuleDiscriminator

export type NotificationRuleDiscriminator =
  | (SlackNotificationRule & {type: string})
  | (SMTPNotificationRule & {type: string})
  | (PagerDutyNotificationRule & {type: string})
  | (HTTPNotificationRule & {type: string})
  | (TelegramNotificationRule & {type: string})

export type SlackNotificationRule = NotificationRuleBase &
  SlackNotificationRuleBase

export interface NotificationRuleBase {
  readonly latestCompleted?: string
  readonly lastRunStatus?: 'failed' | 'success' | 'canceled'
  readonly lastRunError?: string
  readonly id?: string
  endpointID: string
  orgID: string
  taskID?: string
  readonly ownerID?: string
  readonly createdAt?: string
  readonly updatedAt?: string
  status: TaskStatusType
  name: string
  sleepUntil?: string
  every?: string
  offset?: string
  runbookLink?: string
  limitEvery?: number
  limit?: number
  tagRules?: TagRule[]
  description?: string
  statusRules: StatusRule[]
  labels?: Labels
  readonly links?: {
    self?: Link
    labels?: Link
    members?: Link
    owners?: Link
    query?: Link
  }
}

export interface TagRule {
  key?: string
  value?: string
  operator?: 'equal' | 'notequal' | 'equalregex' | 'notequalregex'
}

export interface StatusRule {
  currentLevel?: RuleStatusLevel
  previousLevel?: RuleStatusLevel
  count?: number
  period?: string
}

export type RuleStatusLevel =
  | 'UNKNOWN'
  | 'OK'
  | 'INFO'
  | 'CRIT'
  | 'WARN'
  | 'ANY'

export interface SlackNotificationRuleBase {
  type: 'slack'
  channel?: string
  messageTemplate: string
}

export type SMTPNotificationRule = NotificationRuleBase &
  SMTPNotificationRuleBase

export interface SMTPNotificationRuleBase {
  type: 'smtp'
  subjectTemplate: string
  bodyTemplate?: string
  to: string
}

export type PagerDutyNotificationRule = NotificationRuleBase &
  PagerDutyNotificationRuleBase

export interface PagerDutyNotificationRuleBase {
  type: 'pagerduty'
  messageTemplate: string
}

export type HTTPNotificationRule = NotificationRuleBase &
  HTTPNotificationRuleBase

export interface HTTPNotificationRuleBase {
  type: 'http'
  url?: string
}

export type TelegramNotificationRule = NotificationRuleBase &
  TelegramNotificationRuleBase

export interface TelegramNotificationRuleBase {
  type: 'telegram'
  messageTemplate: string
  parseMode?: 'MarkdownV2' | 'HTML' | 'Markdown'
  disableWebPagePreview?: boolean
}

export type PostNotificationRule = NotificationRuleDiscriminator

export interface FluxResponse {
  flux?: string
}

export interface NotificationRuleUpdate {
  name?: string
  description?: string
  status?: 'active' | 'inactive'
}

export interface NotificationEndpoints {
  notificationEndpoints?: NotificationEndpoint[]
  links?: Links
}

export type NotificationEndpoint = NotificationEndpointDiscriminator

export type PostNotificationEndpoint = NotificationEndpointDiscriminator

export interface NotificationEndpointUpdate {
  name?: string
  description?: string
  status?: 'active' | 'inactive'
}

export interface HealthCheck {
  name: string
  message?: string
  checks?: HealthCheck[]
  status: 'pass' | 'fail'
  version?: string
  commit?: string
}

export interface Ready {
  status?: 'ready'
  started?: string
  up?: string
}

export interface Users {
  links?: {
    self?: string
  }
  users?: UserResponse[]
}

export interface User {
  readonly id?: string
  oauthID?: string
  name: string
  status?: 'active' | 'inactive'
}

export interface IsOnboarding {
  allowed?: boolean
}

export interface OnboardingRequest {
  username: string
  password?: string
  org: string
  bucket: string
  retentionPeriodSeconds?: number
  retentionPeriodHrs?: number
  token?: string
}

export interface OnboardingResponse {
  user?: UserResponse
  org?: Organization
  bucket?: Bucket
  auth?: Authorization
}

export type Authorization = AuthorizationUpdateRequest & {
  readonly createdAt?: string
  readonly updatedAt?: string
  orgID?: string
  permissions?: Permission[]
  readonly id?: string
  readonly token?: string
  readonly userID?: string
  readonly user?: string
  readonly org?: string
  readonly links?: {
    readonly self?: Link
    readonly user?: Link
  }
}

export interface AuthorizationUpdateRequest {
  status?: 'active' | 'inactive'
  description?: string
}

export interface Permission {
  action: 'read' | 'write'
  resource: Resource
}

export interface Resource {
  type:
    | 'authorizations'
    | 'buckets'
    | 'dashboards'
    | 'orgs'
    | 'sources'
    | 'tasks'
    | 'telegrafs'
    | 'users'
    | 'variables'
    | 'scrapers'
    | 'secrets'
    | 'labels'
    | 'views'
    | 'documents'
    | 'notificationRules'
    | 'notificationEndpoints'
    | 'checks'
    | 'dbrp'
    | 'notebooks'
    | 'annotations'
    | 'remotes'
    | 'replications'
  id?: string
  name?: string
  orgID?: string
  org?: string
}

export interface Authorizations {
  readonly links?: Links
  authorizations?: Authorization[]
}

export type AuthorizationPostRequest = AuthorizationUpdateRequest & {
  orgID?: string
  userID?: string
  permissions?: Permission[]
}

export interface Variables {
  variables?: Variable[]
}

export interface Variable {
  readonly links?: {
    self?: string
    org?: string
    labels?: string
  }
  readonly id?: string
  orgID: string
  name: string
  description?: string
  selected?: string[]
  labels?: Labels
  arguments: VariableProperties
  createdAt?: string
  updatedAt?: string
}

export interface Sources {
  links?: {
    self?: string
  }
  sources?: Source[]
}

export interface Source {
  links?: {
    self?: string
    query?: string
    health?: string
    buckets?: string
  }
  id?: string
  orgID?: string
  default?: boolean
  name?: string
  type?: 'v1' | 'v2' | 'self'
  url?: string
  insecureSkipVerify?: boolean
  telegraf?: string
  token?: string
  username?: string
  password?: string
  sharedSecret?: string
  metaUrl?: string
  defaultRP?: string
  readonly languages?: Array<'flux' | 'influxql'>
}

export interface ScraperTargetResponses {
  configurations?: ScraperTargetResponse[]
}

export type ScraperTargetResponse = ScraperTargetRequest & {
  readonly id?: string
  org?: string
  bucket?: string
  readonly links?: {
    self?: Link
    members?: Link
    owners?: Link
    bucket?: Link
    organization?: Link
  }
}

export interface ScraperTargetRequest {
  name?: string
  type?: 'prometheus'
  url?: string
  orgID?: string
  bucketID?: string
  allowInsecure?: boolean
}

export interface MetadataBackup {
  kv: string
  sql: string
  buckets: BucketMetadataManifests
}

export type BucketMetadataManifests = BucketMetadataManifest[]

export interface BucketMetadataManifest {
  organizationID: string
  organizationName: string
  bucketID: string
  bucketName: string
  description?: string
  defaultRetentionPolicy: string
  retentionPolicies: RetentionPolicyManifests
}

export type RetentionPolicyManifests = RetentionPolicyManifest[]

export interface RetentionPolicyManifest {
  name: string
  replicaN: number
  duration: number
  shardGroupDuration: number
  shardGroups: ShardGroupManifests
  subscriptions: SubscriptionManifests
}

export type ShardGroupManifests = ShardGroupManifest[]

export interface ShardGroupManifest {
  id: number
  startTime: string
  endTime: string
  deletedAt?: string
  truncatedAt?: string
  shards: ShardManifests
}

export type ShardManifests = ShardManifest[]

export interface ShardManifest {
  id: number
  shardOwners: ShardOwners
}

export type ShardOwners = ShardOwner[]

export interface ShardOwner {
  nodeID: number
}

export type SubscriptionManifests = SubscriptionManifest[]

export interface SubscriptionManifest {
  name: string
  mode: string
  destinations: string[]
}

export interface RestoredBucketMappings {
  id: string
  name: string
  shardMappings: BucketShardMappings
}

export type BucketShardMappings = BucketShardMapping[]

export interface BucketShardMapping {
  oldId: number
  newId: number
}

export interface Config {
  config?: any
}

export interface RemoteConnections {
  remotes?: RemoteConnection[]
}

export interface RemoteConnection {
  id: string
  name: string
  orgID: string
  description?: string
  remoteURL: string
  remoteOrgID: string
  allowInsecureTLS: boolean
}

export interface RemoteConnectionCreationRequest {
  name: string
  description?: string
  orgID: string
  remoteURL: string
  remoteAPIToken: string
  remoteOrgID: string
  allowInsecureTLS: boolean
}

export interface RemoteConnectionUpdateRequest {
  name?: string
  description?: string
  remoteURL?: string
  remoteAPIToken?: string
  remoteOrgID?: string
  allowInsecureTLS?: boolean
}

export interface Replications {
  replications?: Replication[]
}

export interface Replication {
  id: string
  name: string
  description?: string
  orgID: string
  remoteID: string
  localBucketID: string
  remoteBucketID: string
  maxQueueSizeBytes: number
  currentQueueSizeBytes: number
  latestResponseCode?: number
  latestErrorMessage?: string
  dropNonRetryableData?: boolean
}

export interface ReplicationCreationRequest {
  name: string
  description?: string
  orgID: string
  remoteID: string
  localBucketID: string
  remoteBucketID: string
  maxQueueSizeBytes: number
  dropNonRetryableData?: boolean
  maxAgeSeconds: number
}

export interface ReplicationUpdateRequest {
  name?: string
  description?: string
  remoteID?: string
  remoteBucketID?: string
  maxQueueSizeBytes?: number
  dropNonRetryableData?: boolean
  maxAgeSeconds?: number
}

export interface Dashboards {
  links?: Links
  dashboards?: Dashboard[]
}

export interface Tasks {
  readonly links?: Links
  tasks?: Task[]
}

export interface Task {
  readonly id: string
  orgID: string
  org?: string
  name: string
  ownerID?: string
  description?: string
  status?: TaskStatusType
  labels?: Labels
  authorizationID?: string
  flux: string
  every?: string
  cron?: string
  offset?: string
  readonly latestCompleted?: string
  readonly lastRunStatus?: 'failed' | 'success' | 'canceled'
  readonly lastRunError?: string
  readonly createdAt?: string
  readonly updatedAt?: string
  readonly links?: {
    self?: Link
    owners?: Link
    members?: Link
    runs?: Link
    logs?: Link
    labels?: Link
  }
}

export interface TaskCreateRequest {
  orgID?: string
  org?: string
  status?: TaskStatusType
  flux: string
  description?: string
}

export type BadRequestError = any

export interface TaskUpdateRequest {
  status?: TaskStatusType
  flux?: string
  name?: string
  every?: string
  cron?: string
  offset?: string
  description?: string
}

interface RequestOptions {
  signal?: AbortSignal
}

export type RequestHandler = (
  url: string,
  query: string,
  init: RequestInit
) => {url: string; query: string; init: RequestInit}
export type ResponseHandler = (
  status: number,
  headers: Headers,
  data: any
) => {status: number; headers: Headers; data: any}

const RequestContext = function(
  requestHandler: RequestHandler,
  responseHandler: ResponseHandler
) {
  this.requestHandler = requestHandler
  this.responseHandler = responseHandler
}

RequestContext.prototype.request = async function(
  method: string,
  url: string,
  params: any = {},
  options: RequestOptions = {}
): Promise<any> {
  const requestHeaders = new Headers(params.headers)
  const contentType = requestHeaders.get('Content-Type') || ''

  if (params.auth) {
    const credentials = btoa(`${params.auth.username}:${params.auth.password}`)

    requestHeaders.append('Authorization', `Basic ${credentials}`)
  }

  const body =
    params.data && contentType.includes('json')
      ? JSON.stringify(params.data)
      : params.data

  const query = params.query ? `?${new URLSearchParams(params.query)}` : ''

  const {
    url: middlewareUrl,
    query: middlewareQuery,
    init,
  } = this.requestHandler(url, query, {
    method,
    body,
    credentials: 'same-origin',
    signal: options.signal,
    headers: requestHeaders,
  })

  const response = await fetch(`${middlewareUrl}${middlewareQuery}`, init)

  const {status, headers} = response
  const responseContentType = headers.get('Content-Type') || ''

  let data

  if (responseContentType.includes('json')) {
    data = await response.json()
  } else if (responseContentType.includes('octet-stream')) {
    data = await response.blob()
  } else {
    data = await response.text()
  }

  return this.responseHandler(status, headers, data)
}

RequestContext.prototype.setRequestHandler = function(
  requestHandler: RequestHandler
) {
  this.requestHandler = requestHandler
}

RequestContext.prototype.setResponseHandler = function(
  responseHandler: ResponseHandler
) {
  this.responseHandler = responseHandler
}

const rc = new RequestContext(
  (url, query, init) => {
    return {url, query, init}
  },
  (status, headers, data) => {
    return {status, headers, data}
  }
)
const request = rc.request.bind(rc)
const setRequestHandler = rc.setRequestHandler.bind(rc)
const setResponseHandler = rc.setResponseHandler.bind(rc)

export {request, setRequestHandler, setResponseHandler}

export interface PostSigninParams {
  headers?: {
    'Zap-Trace-Span'?: string
  }

  auth: {
    username: string
    password: string
  }
}

type PostSigninResult =
  | PostSigninNoContentResult
  | PostSigninUnauthorizedResult
  | PostSigninForbiddenResult
  | PostSigninDefaultResult

interface PostSigninNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface PostSigninUnauthorizedResult {
  status: 401
  headers: Headers
  data: Error
}

interface PostSigninForbiddenResult {
  status: 403
  headers: Headers
  data: Error
}

interface PostSigninDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postSignin = (
  params: PostSigninParams,
  options: RequestOptions = {}
): Promise<PostSigninResult> =>
  request('POST', '/api/v2/signin', params, options) as Promise<
    PostSigninResult
  >

export interface PostSignoutParams {
  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostSignoutResult =
  | PostSignoutNoContentResult
  | PostSignoutUnauthorizedResult
  | PostSignoutDefaultResult

interface PostSignoutNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface PostSignoutUnauthorizedResult {
  status: 401
  headers: Headers
  data: Error
}

interface PostSignoutDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postSignout = (
  params: PostSignoutParams,
  options: RequestOptions = {}
): Promise<PostSignoutResult> =>
  request('POST', '/api/v2/signout', params, options) as Promise<
    PostSignoutResult
  >

export interface GetPingParams {}

type GetPingResult = GetPingNoContentResult

interface GetPingNoContentResult {
  status: 204
  headers: Headers
  data: any
}

export const getPing = (
  params: GetPingParams,
  options: RequestOptions = {}
): Promise<GetPingResult> =>
  request('GET', '/api/v2/ping', params, options) as Promise<GetPingResult>

export interface GetParams {
  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetResult = GetDefaultResult

interface GetDefaultResult {
  status: 500
  headers: Headers
  data: Routes
}

export const get = (
  params: GetParams,
  options: RequestOptions = {}
): Promise<GetResult> =>
  request('GET', '/api/v2/', params, options) as Promise<GetResult>

export interface GetDbrpsParams {
  query?: {
    orgID?: string
    org?: string
    id?: string
    bucketID?: string
    default?: any
    db?: string
    rp?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetDbrpsResult =
  | GetDbrpsOKResult
  | GetDbrpsBadRequestResult
  | GetDbrpsDefaultResult

interface GetDbrpsOKResult {
  status: 200
  headers: Headers
  data: DBRPs
}

interface GetDbrpsBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface GetDbrpsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getDbrps = (
  params: GetDbrpsParams,
  options: RequestOptions = {}
): Promise<GetDbrpsResult> =>
  request('GET', '/api/v2/dbrps', params, options) as Promise<GetDbrpsResult>

export interface PostDbrpParams {
  data: DBRPCreate

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostDbrpResult =
  | PostDbrpCreatedResult
  | PostDbrpBadRequestResult
  | PostDbrpDefaultResult

interface PostDbrpCreatedResult {
  status: 201
  headers: Headers
  data: DBRP
}

interface PostDbrpBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface PostDbrpDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postDbrp = (
  params: PostDbrpParams,
  options: RequestOptions = {}
): Promise<PostDbrpResult> =>
  request(
    'POST',
    '/api/v2/dbrps',
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostDbrpResult>

export interface GetDbrpParams {
  dbrpID: string

  query?: {
    orgID?: string
    org?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetDbrpResult =
  | GetDbrpOKResult
  | GetDbrpBadRequestResult
  | GetDbrpDefaultResult

interface GetDbrpOKResult {
  status: 200
  headers: Headers
  data: DBRPGet
}

interface GetDbrpBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface GetDbrpDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getDbrp = (
  params: GetDbrpParams,
  options: RequestOptions = {}
): Promise<GetDbrpResult> =>
  request('GET', `/api/v2/dbrps/${params.dbrpID}`, params, options) as Promise<
    GetDbrpResult
  >

export interface PatchDbrpParams {
  dbrpID: string

  data: DBRPUpdate

  query?: {
    orgID?: string
    org?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PatchDbrpResult =
  | PatchDbrpOKResult
  | PatchDbrpBadRequestResult
  | PatchDbrpNotFoundResult
  | PatchDbrpDefaultResult

interface PatchDbrpOKResult {
  status: 200
  headers: Headers
  data: DBRPGet
}

interface PatchDbrpBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface PatchDbrpNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface PatchDbrpDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const patchDbrp = (
  params: PatchDbrpParams,
  options: RequestOptions = {}
): Promise<PatchDbrpResult> =>
  request(
    'PATCH',
    `/api/v2/dbrps/${params.dbrpID}`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PatchDbrpResult>

export interface DeleteDbrpParams {
  dbrpID: string

  query?: {
    orgID?: string
    org?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteDbrpResult =
  | DeleteDbrpNoContentResult
  | DeleteDbrpBadRequestResult
  | DeleteDbrpDefaultResult

interface DeleteDbrpNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteDbrpBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface DeleteDbrpDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteDbrp = (
  params: DeleteDbrpParams,
  options: RequestOptions = {}
): Promise<DeleteDbrpResult> =>
  request(
    'DELETE',
    `/api/v2/dbrps/${params.dbrpID}`,
    params,
    options
  ) as Promise<DeleteDbrpResult>

export interface GetTelegrafPluginsParams {
  query?: {
    type?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetTelegrafPluginsResult =
  | GetTelegrafPluginsOKResult
  | GetTelegrafPluginsDefaultResult

interface GetTelegrafPluginsOKResult {
  status: 200
  headers: Headers
  data: TelegrafPlugins
}

interface GetTelegrafPluginsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getTelegrafPlugins = (
  params: GetTelegrafPluginsParams,
  options: RequestOptions = {}
): Promise<GetTelegrafPluginsResult> =>
  request('GET', '/api/v2/telegraf/plugins', params, options) as Promise<
    GetTelegrafPluginsResult
  >

export interface GetTelegrafsParams {
  query?: {
    orgID?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetTelegrafsResult = GetTelegrafsOKResult | GetTelegrafsDefaultResult

interface GetTelegrafsOKResult {
  status: 200
  headers: Headers
  data: Telegrafs
}

interface GetTelegrafsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getTelegrafs = (
  params: GetTelegrafsParams,
  options: RequestOptions = {}
): Promise<GetTelegrafsResult> =>
  request('GET', '/api/v2/telegrafs', params, options) as Promise<
    GetTelegrafsResult
  >

export interface PostTelegrafParams {
  data: TelegrafPluginRequest

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostTelegrafResult = PostTelegrafCreatedResult | PostTelegrafDefaultResult

interface PostTelegrafCreatedResult {
  status: 201
  headers: Headers
  data: Telegraf
}

interface PostTelegrafDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postTelegraf = (
  params: PostTelegrafParams,
  options: RequestOptions = {}
): Promise<PostTelegrafResult> =>
  request(
    'POST',
    '/api/v2/telegrafs',
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostTelegrafResult>

export interface GetTelegrafParams {
  telegrafID: string

  headers?: {
    'Zap-Trace-Span'?: string
    Accept?: string
  }
}

type GetTelegrafResult = GetTelegrafOKResult | GetTelegrafDefaultResult

interface GetTelegrafOKResult {
  status: 200
  headers: Headers
  data: Telegraf
}

interface GetTelegrafDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getTelegraf = (
  params: GetTelegrafParams,
  options: RequestOptions = {}
): Promise<GetTelegrafResult> =>
  request(
    'GET',
    `/api/v2/telegrafs/${params.telegrafID}`,
    params,
    options
  ) as Promise<GetTelegrafResult>

export interface PutTelegrafParams {
  telegrafID: string

  data: TelegrafPluginRequest

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PutTelegrafResult = PutTelegrafOKResult | PutTelegrafDefaultResult

interface PutTelegrafOKResult {
  status: 200
  headers: Headers
  data: Telegraf
}

interface PutTelegrafDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const putTelegraf = (
  params: PutTelegrafParams,
  options: RequestOptions = {}
): Promise<PutTelegrafResult> =>
  request(
    'PUT',
    `/api/v2/telegrafs/${params.telegrafID}`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PutTelegrafResult>

export interface DeleteTelegrafParams {
  telegrafID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteTelegrafResult =
  | DeleteTelegrafNoContentResult
  | DeleteTelegrafDefaultResult

interface DeleteTelegrafNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteTelegrafDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteTelegraf = (
  params: DeleteTelegrafParams,
  options: RequestOptions = {}
): Promise<DeleteTelegrafResult> =>
  request(
    'DELETE',
    `/api/v2/telegrafs/${params.telegrafID}`,
    params,
    options
  ) as Promise<DeleteTelegrafResult>

export interface GetTelegrafsLabelsParams {
  telegrafID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetTelegrafsLabelsResult =
  | GetTelegrafsLabelsOKResult
  | GetTelegrafsLabelsDefaultResult

interface GetTelegrafsLabelsOKResult {
  status: 200
  headers: Headers
  data: LabelsResponse
}

interface GetTelegrafsLabelsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getTelegrafsLabels = (
  params: GetTelegrafsLabelsParams,
  options: RequestOptions = {}
): Promise<GetTelegrafsLabelsResult> =>
  request(
    'GET',
    `/api/v2/telegrafs/${params.telegrafID}/labels`,
    params,
    options
  ) as Promise<GetTelegrafsLabelsResult>

export interface PostTelegrafsLabelParams {
  telegrafID: string

  data: LabelMapping

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostTelegrafsLabelResult =
  | PostTelegrafsLabelCreatedResult
  | PostTelegrafsLabelDefaultResult

interface PostTelegrafsLabelCreatedResult {
  status: 201
  headers: Headers
  data: LabelResponse
}

interface PostTelegrafsLabelDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postTelegrafsLabel = (
  params: PostTelegrafsLabelParams,
  options: RequestOptions = {}
): Promise<PostTelegrafsLabelResult> =>
  request(
    'POST',
    `/api/v2/telegrafs/${params.telegrafID}/labels`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostTelegrafsLabelResult>

export interface DeleteTelegrafsLabelParams {
  telegrafID: string
  labelID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteTelegrafsLabelResult =
  | DeleteTelegrafsLabelNoContentResult
  | DeleteTelegrafsLabelNotFoundResult
  | DeleteTelegrafsLabelDefaultResult

interface DeleteTelegrafsLabelNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteTelegrafsLabelNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface DeleteTelegrafsLabelDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteTelegrafsLabel = (
  params: DeleteTelegrafsLabelParams,
  options: RequestOptions = {}
): Promise<DeleteTelegrafsLabelResult> =>
  request(
    'DELETE',
    `/api/v2/telegrafs/${params.telegrafID}/labels/${params.labelID}`,
    params,
    options
  ) as Promise<DeleteTelegrafsLabelResult>

export interface GetTelegrafsMembersParams {
  telegrafID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetTelegrafsMembersResult =
  | GetTelegrafsMembersOKResult
  | GetTelegrafsMembersDefaultResult

interface GetTelegrafsMembersOKResult {
  status: 200
  headers: Headers
  data: ResourceMembers
}

interface GetTelegrafsMembersDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getTelegrafsMembers = (
  params: GetTelegrafsMembersParams,
  options: RequestOptions = {}
): Promise<GetTelegrafsMembersResult> =>
  request(
    'GET',
    `/api/v2/telegrafs/${params.telegrafID}/members`,
    params,
    options
  ) as Promise<GetTelegrafsMembersResult>

export interface PostTelegrafsMemberParams {
  telegrafID: string

  data: AddResourceMemberRequestBody

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostTelegrafsMemberResult =
  | PostTelegrafsMemberCreatedResult
  | PostTelegrafsMemberDefaultResult

interface PostTelegrafsMemberCreatedResult {
  status: 201
  headers: Headers
  data: ResourceMember
}

interface PostTelegrafsMemberDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postTelegrafsMember = (
  params: PostTelegrafsMemberParams,
  options: RequestOptions = {}
): Promise<PostTelegrafsMemberResult> =>
  request(
    'POST',
    `/api/v2/telegrafs/${params.telegrafID}/members`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostTelegrafsMemberResult>

export interface DeleteTelegrafsMemberParams {
  userID: string
  telegrafID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteTelegrafsMemberResult =
  | DeleteTelegrafsMemberNoContentResult
  | DeleteTelegrafsMemberDefaultResult

interface DeleteTelegrafsMemberNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteTelegrafsMemberDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteTelegrafsMember = (
  params: DeleteTelegrafsMemberParams,
  options: RequestOptions = {}
): Promise<DeleteTelegrafsMemberResult> =>
  request(
    'DELETE',
    `/api/v2/telegrafs/${params.telegrafID}/members/${params.userID}`,
    params,
    options
  ) as Promise<DeleteTelegrafsMemberResult>

export interface GetTelegrafsOwnersParams {
  telegrafID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetTelegrafsOwnersResult =
  | GetTelegrafsOwnersOKResult
  | GetTelegrafsOwnersDefaultResult

interface GetTelegrafsOwnersOKResult {
  status: 200
  headers: Headers
  data: ResourceOwners
}

interface GetTelegrafsOwnersDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getTelegrafsOwners = (
  params: GetTelegrafsOwnersParams,
  options: RequestOptions = {}
): Promise<GetTelegrafsOwnersResult> =>
  request(
    'GET',
    `/api/v2/telegrafs/${params.telegrafID}/owners`,
    params,
    options
  ) as Promise<GetTelegrafsOwnersResult>

export interface PostTelegrafsOwnerParams {
  telegrafID: string

  data: AddResourceMemberRequestBody

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostTelegrafsOwnerResult =
  | PostTelegrafsOwnerCreatedResult
  | PostTelegrafsOwnerDefaultResult

interface PostTelegrafsOwnerCreatedResult {
  status: 201
  headers: Headers
  data: ResourceOwner
}

interface PostTelegrafsOwnerDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postTelegrafsOwner = (
  params: PostTelegrafsOwnerParams,
  options: RequestOptions = {}
): Promise<PostTelegrafsOwnerResult> =>
  request(
    'POST',
    `/api/v2/telegrafs/${params.telegrafID}/owners`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostTelegrafsOwnerResult>

export interface DeleteTelegrafsOwnerParams {
  userID: string
  telegrafID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteTelegrafsOwnerResult =
  | DeleteTelegrafsOwnerNoContentResult
  | DeleteTelegrafsOwnerDefaultResult

interface DeleteTelegrafsOwnerNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteTelegrafsOwnerDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteTelegrafsOwner = (
  params: DeleteTelegrafsOwnerParams,
  options: RequestOptions = {}
): Promise<DeleteTelegrafsOwnerResult> =>
  request(
    'DELETE',
    `/api/v2/telegrafs/${params.telegrafID}/owners/${params.userID}`,
    params,
    options
  ) as Promise<DeleteTelegrafsOwnerResult>

export interface GetVariablesLabelsParams {
  variableID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetVariablesLabelsResult =
  | GetVariablesLabelsOKResult
  | GetVariablesLabelsDefaultResult

interface GetVariablesLabelsOKResult {
  status: 200
  headers: Headers
  data: LabelsResponse
}

interface GetVariablesLabelsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getVariablesLabels = (
  params: GetVariablesLabelsParams,
  options: RequestOptions = {}
): Promise<GetVariablesLabelsResult> =>
  request(
    'GET',
    `/api/v2/variables/${params.variableID}/labels`,
    params,
    options
  ) as Promise<GetVariablesLabelsResult>

export interface PostVariablesLabelParams {
  variableID: string

  data: LabelMapping

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostVariablesLabelResult =
  | PostVariablesLabelCreatedResult
  | PostVariablesLabelDefaultResult

interface PostVariablesLabelCreatedResult {
  status: 201
  headers: Headers
  data: LabelResponse
}

interface PostVariablesLabelDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postVariablesLabel = (
  params: PostVariablesLabelParams,
  options: RequestOptions = {}
): Promise<PostVariablesLabelResult> =>
  request(
    'POST',
    `/api/v2/variables/${params.variableID}/labels`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostVariablesLabelResult>

export interface DeleteVariablesLabelParams {
  variableID: string
  labelID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteVariablesLabelResult =
  | DeleteVariablesLabelNoContentResult
  | DeleteVariablesLabelNotFoundResult
  | DeleteVariablesLabelDefaultResult

interface DeleteVariablesLabelNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteVariablesLabelNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface DeleteVariablesLabelDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteVariablesLabel = (
  params: DeleteVariablesLabelParams,
  options: RequestOptions = {}
): Promise<DeleteVariablesLabelResult> =>
  request(
    'DELETE',
    `/api/v2/variables/${params.variableID}/labels/${params.labelID}`,
    params,
    options
  ) as Promise<DeleteVariablesLabelResult>

export interface PostWriteParams {
  data: string

  query: {
    org: string
    orgID?: string
    bucket: string
    precision?: any
  }

  headers?: {
    'Zap-Trace-Span'?: string
    'Content-Encoding'?: string
    'Content-Type'?: string
    'Content-Length'?: number
    Accept?: string
  }
}

type PostWriteResult =
  | PostWriteNoContentResult
  | PostWriteBadRequestResult
  | PostWriteUnauthorizedResult
  | PostWriteNotFoundResult
  | PostWritePayloadTooLargeResult
  | PostWriteTooManyRequestsResult
  | PostWriteInternalServerErrorResult
  | PostWriteServiceUnavailableResult
  | PostWriteDefaultResult

interface PostWriteNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface PostWriteBadRequestResult {
  status: 400
  headers: Headers
  data: LineProtocolError
}

interface PostWriteUnauthorizedResult {
  status: 401
  headers: Headers
  data: Error
}

interface PostWriteNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface PostWritePayloadTooLargeResult {
  status: 413
  headers: Headers
  data: LineProtocolLengthError
}

interface PostWriteTooManyRequestsResult {
  status: 429
  headers: Headers
  data: any
}

interface PostWriteInternalServerErrorResult {
  status: 500
  headers: Headers
  data: Error
}

interface PostWriteServiceUnavailableResult {
  status: 503
  headers: Headers
  data: any
}

interface PostWriteDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postWrite = (
  params: PostWriteParams,
  options: RequestOptions = {}
): Promise<PostWriteResult> =>
  request(
    'POST',
    '/api/v2/write',
    {...params, headers: {...params.headers, 'Content-Type': 'text/plain'}},
    options
  ) as Promise<PostWriteResult>

export interface PostDeleteParams {
  data: DeletePredicateRequest

  query?: {
    org?: string
    bucket?: string
    orgID?: string
    bucketID?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostDeleteResult =
  | PostDeleteNoContentResult
  | PostDeleteBadRequestResult
  | PostDeleteUnauthorizedResult
  | PostDeleteNotFoundResult
  | PostDeleteInternalServerErrorResult
  | PostDeleteDefaultResult

interface PostDeleteNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface PostDeleteBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface PostDeleteUnauthorizedResult {
  status: 401
  headers: Headers
  data: Error
}

interface PostDeleteNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface PostDeleteInternalServerErrorResult {
  status: 500
  headers: Headers
  data: Error
}

interface PostDeleteDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postDelete = (
  params: PostDeleteParams,
  options: RequestOptions = {}
): Promise<PostDeleteResult> =>
  request(
    'POST',
    '/api/v2/delete',
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostDeleteResult>

export interface GetLabelsParams {
  query?: {
    orgID?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetLabelsResult =
  | GetLabelsOKResult
  | GetLabelsInternalServerErrorResult
  | GetLabelsDefaultResult

interface GetLabelsOKResult {
  status: 200
  headers: Headers
  data: LabelsResponse
}

interface GetLabelsInternalServerErrorResult {
  status: 500
  headers: Headers
  data: Error
}

interface GetLabelsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getLabels = (
  params: GetLabelsParams,
  options: RequestOptions = {}
): Promise<GetLabelsResult> =>
  request('GET', '/api/v2/labels', params, options) as Promise<GetLabelsResult>

export interface PostLabelParams {
  data: LabelCreateRequest
}

type PostLabelResult =
  | PostLabelCreatedResult
  | PostLabelInternalServerErrorResult
  | PostLabelDefaultResult

interface PostLabelCreatedResult {
  status: 201
  headers: Headers
  data: LabelResponse
}

interface PostLabelInternalServerErrorResult {
  status: 500
  headers: Headers
  data: Error
}

interface PostLabelDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postLabel = (
  params: PostLabelParams,
  options: RequestOptions = {}
): Promise<PostLabelResult> =>
  request(
    'POST',
    '/api/v2/labels',
    {...params, headers: {'Content-Type': 'application/json'}},
    options
  ) as Promise<PostLabelResult>

export interface GetLabelParams {
  labelID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetLabelResult =
  | GetLabelOKResult
  | GetLabelInternalServerErrorResult
  | GetLabelDefaultResult

interface GetLabelOKResult {
  status: 200
  headers: Headers
  data: LabelResponse
}

interface GetLabelInternalServerErrorResult {
  status: 500
  headers: Headers
  data: Error
}

interface GetLabelDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getLabel = (
  params: GetLabelParams,
  options: RequestOptions = {}
): Promise<GetLabelResult> =>
  request(
    'GET',
    `/api/v2/labels/${params.labelID}`,
    params,
    options
  ) as Promise<GetLabelResult>

export interface PatchLabelParams {
  labelID: string

  data: LabelUpdate

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PatchLabelResult =
  | PatchLabelOKResult
  | PatchLabelUnauthorizedResult
  | PatchLabelNotFoundResult
  | PatchLabelInternalServerErrorResult
  | PatchLabelDefaultResult

interface PatchLabelOKResult {
  status: 200
  headers: Headers
  data: LabelResponse
}

interface PatchLabelUnauthorizedResult {
  status: 401
  headers: Headers
  data: Error
}

interface PatchLabelNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface PatchLabelInternalServerErrorResult {
  status: 500
  headers: Headers
  data: Error
}

interface PatchLabelDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const patchLabel = (
  params: PatchLabelParams,
  options: RequestOptions = {}
): Promise<PatchLabelResult> =>
  request(
    'PATCH',
    `/api/v2/labels/${params.labelID}`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PatchLabelResult>

export interface DeleteLabelParams {
  labelID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteLabelResult =
  | DeleteLabelNoContentResult
  | DeleteLabelUnauthorizedResult
  | DeleteLabelNotFoundResult
  | DeleteLabelInternalServerErrorResult
  | DeleteLabelDefaultResult

interface DeleteLabelNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteLabelUnauthorizedResult {
  status: 401
  headers: Headers
  data: Error
}

interface DeleteLabelNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface DeleteLabelInternalServerErrorResult {
  status: 500
  headers: Headers
  data: Error
}

interface DeleteLabelDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteLabel = (
  params: DeleteLabelParams,
  options: RequestOptions = {}
): Promise<DeleteLabelResult> =>
  request(
    'DELETE',
    `/api/v2/labels/${params.labelID}`,
    params,
    options
  ) as Promise<DeleteLabelResult>

export interface GetDashboardParams {
  dashboardID: string

  query?: {
    include?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetDashboardResult =
  | GetDashboardOKResult
  | GetDashboardNotFoundResult
  | GetDashboardDefaultResult

interface GetDashboardOKResult {
  status: 200
  headers: Headers
  data: Dashboard | DashboardWithViewProperties
}

interface GetDashboardNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface GetDashboardDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getDashboard = (
  params: GetDashboardParams,
  options: RequestOptions = {}
): Promise<GetDashboardResult> =>
  request(
    'GET',
    `/api/v2/dashboards/${params.dashboardID}`,
    params,
    options
  ) as Promise<GetDashboardResult>

export interface PatchDashboardParams {
  dashboardID: string

  data: {
    name?: string
    description?: string
    cells?: CellWithViewProperties
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PatchDashboardResult =
  | PatchDashboardOKResult
  | PatchDashboardNotFoundResult
  | PatchDashboardDefaultResult

interface PatchDashboardOKResult {
  status: 200
  headers: Headers
  data: Dashboard
}

interface PatchDashboardNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface PatchDashboardDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const patchDashboard = (
  params: PatchDashboardParams,
  options: RequestOptions = {}
): Promise<PatchDashboardResult> =>
  request(
    'PATCH',
    `/api/v2/dashboards/${params.dashboardID}`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PatchDashboardResult>

export interface DeleteDashboardParams {
  dashboardID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteDashboardResult =
  | DeleteDashboardNoContentResult
  | DeleteDashboardNotFoundResult
  | DeleteDashboardDefaultResult

interface DeleteDashboardNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteDashboardNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface DeleteDashboardDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteDashboard = (
  params: DeleteDashboardParams,
  options: RequestOptions = {}
): Promise<DeleteDashboardResult> =>
  request(
    'DELETE',
    `/api/v2/dashboards/${params.dashboardID}`,
    params,
    options
  ) as Promise<DeleteDashboardResult>

export interface PostDashboardsCellParams {
  dashboardID: string

  data: CreateCell

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostDashboardsCellResult =
  | PostDashboardsCellCreatedResult
  | PostDashboardsCellNotFoundResult
  | PostDashboardsCellDefaultResult

interface PostDashboardsCellCreatedResult {
  status: 201
  headers: Headers
  data: Cell
}

interface PostDashboardsCellNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface PostDashboardsCellDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postDashboardsCell = (
  params: PostDashboardsCellParams,
  options: RequestOptions = {}
): Promise<PostDashboardsCellResult> =>
  request(
    'POST',
    `/api/v2/dashboards/${params.dashboardID}/cells`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostDashboardsCellResult>

export interface PutDashboardsCellsParams {
  dashboardID: string

  data: Cells

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PutDashboardsCellsResult =
  | PutDashboardsCellsCreatedResult
  | PutDashboardsCellsNotFoundResult
  | PutDashboardsCellsDefaultResult

interface PutDashboardsCellsCreatedResult {
  status: 201
  headers: Headers
  data: Dashboard
}

interface PutDashboardsCellsNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface PutDashboardsCellsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const putDashboardsCells = (
  params: PutDashboardsCellsParams,
  options: RequestOptions = {}
): Promise<PutDashboardsCellsResult> =>
  request(
    'PUT',
    `/api/v2/dashboards/${params.dashboardID}/cells`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PutDashboardsCellsResult>

export interface PatchDashboardsCellParams {
  dashboardID: string
  cellID: string

  data: CellUpdate

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PatchDashboardsCellResult =
  | PatchDashboardsCellOKResult
  | PatchDashboardsCellNotFoundResult
  | PatchDashboardsCellDefaultResult

interface PatchDashboardsCellOKResult {
  status: 200
  headers: Headers
  data: Cell
}

interface PatchDashboardsCellNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface PatchDashboardsCellDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const patchDashboardsCell = (
  params: PatchDashboardsCellParams,
  options: RequestOptions = {}
): Promise<PatchDashboardsCellResult> =>
  request(
    'PATCH',
    `/api/v2/dashboards/${params.dashboardID}/cells/${params.cellID}`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PatchDashboardsCellResult>

export interface DeleteDashboardsCellParams {
  dashboardID: string
  cellID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteDashboardsCellResult =
  | DeleteDashboardsCellNoContentResult
  | DeleteDashboardsCellNotFoundResult
  | DeleteDashboardsCellDefaultResult

interface DeleteDashboardsCellNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteDashboardsCellNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface DeleteDashboardsCellDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteDashboardsCell = (
  params: DeleteDashboardsCellParams,
  options: RequestOptions = {}
): Promise<DeleteDashboardsCellResult> =>
  request(
    'DELETE',
    `/api/v2/dashboards/${params.dashboardID}/cells/${params.cellID}`,
    params,
    options
  ) as Promise<DeleteDashboardsCellResult>

export interface GetDashboardsCellsViewParams {
  dashboardID: string
  cellID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetDashboardsCellsViewResult =
  | GetDashboardsCellsViewOKResult
  | GetDashboardsCellsViewNotFoundResult
  | GetDashboardsCellsViewDefaultResult

interface GetDashboardsCellsViewOKResult {
  status: 200
  headers: Headers
  data: View
}

interface GetDashboardsCellsViewNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface GetDashboardsCellsViewDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getDashboardsCellsView = (
  params: GetDashboardsCellsViewParams,
  options: RequestOptions = {}
): Promise<GetDashboardsCellsViewResult> =>
  request(
    'GET',
    `/api/v2/dashboards/${params.dashboardID}/cells/${params.cellID}/view`,
    params,
    options
  ) as Promise<GetDashboardsCellsViewResult>

export interface PatchDashboardsCellsViewParams {
  dashboardID: string
  cellID: string

  data: View

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PatchDashboardsCellsViewResult =
  | PatchDashboardsCellsViewOKResult
  | PatchDashboardsCellsViewNotFoundResult
  | PatchDashboardsCellsViewDefaultResult

interface PatchDashboardsCellsViewOKResult {
  status: 200
  headers: Headers
  data: View
}

interface PatchDashboardsCellsViewNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface PatchDashboardsCellsViewDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const patchDashboardsCellsView = (
  params: PatchDashboardsCellsViewParams,
  options: RequestOptions = {}
): Promise<PatchDashboardsCellsViewResult> =>
  request(
    'PATCH',
    `/api/v2/dashboards/${params.dashboardID}/cells/${params.cellID}/view`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PatchDashboardsCellsViewResult>

export interface GetDashboardsLabelsParams {
  dashboardID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetDashboardsLabelsResult =
  | GetDashboardsLabelsOKResult
  | GetDashboardsLabelsDefaultResult

interface GetDashboardsLabelsOKResult {
  status: 200
  headers: Headers
  data: LabelsResponse
}

interface GetDashboardsLabelsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getDashboardsLabels = (
  params: GetDashboardsLabelsParams,
  options: RequestOptions = {}
): Promise<GetDashboardsLabelsResult> =>
  request(
    'GET',
    `/api/v2/dashboards/${params.dashboardID}/labels`,
    params,
    options
  ) as Promise<GetDashboardsLabelsResult>

export interface PostDashboardsLabelParams {
  dashboardID: string

  data: LabelMapping

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostDashboardsLabelResult =
  | PostDashboardsLabelCreatedResult
  | PostDashboardsLabelDefaultResult

interface PostDashboardsLabelCreatedResult {
  status: 201
  headers: Headers
  data: LabelResponse
}

interface PostDashboardsLabelDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postDashboardsLabel = (
  params: PostDashboardsLabelParams,
  options: RequestOptions = {}
): Promise<PostDashboardsLabelResult> =>
  request(
    'POST',
    `/api/v2/dashboards/${params.dashboardID}/labels`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostDashboardsLabelResult>

export interface DeleteDashboardsLabelParams {
  dashboardID: string
  labelID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteDashboardsLabelResult =
  | DeleteDashboardsLabelNoContentResult
  | DeleteDashboardsLabelNotFoundResult
  | DeleteDashboardsLabelDefaultResult

interface DeleteDashboardsLabelNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteDashboardsLabelNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface DeleteDashboardsLabelDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteDashboardsLabel = (
  params: DeleteDashboardsLabelParams,
  options: RequestOptions = {}
): Promise<DeleteDashboardsLabelResult> =>
  request(
    'DELETE',
    `/api/v2/dashboards/${params.dashboardID}/labels/${params.labelID}`,
    params,
    options
  ) as Promise<DeleteDashboardsLabelResult>

export interface GetDashboardsMembersParams {
  dashboardID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetDashboardsMembersResult =
  | GetDashboardsMembersOKResult
  | GetDashboardsMembersDefaultResult

interface GetDashboardsMembersOKResult {
  status: 200
  headers: Headers
  data: ResourceMembers
}

interface GetDashboardsMembersDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getDashboardsMembers = (
  params: GetDashboardsMembersParams,
  options: RequestOptions = {}
): Promise<GetDashboardsMembersResult> =>
  request(
    'GET',
    `/api/v2/dashboards/${params.dashboardID}/members`,
    params,
    options
  ) as Promise<GetDashboardsMembersResult>

export interface PostDashboardsMemberParams {
  dashboardID: string

  data: AddResourceMemberRequestBody

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostDashboardsMemberResult =
  | PostDashboardsMemberCreatedResult
  | PostDashboardsMemberDefaultResult

interface PostDashboardsMemberCreatedResult {
  status: 201
  headers: Headers
  data: ResourceMember
}

interface PostDashboardsMemberDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postDashboardsMember = (
  params: PostDashboardsMemberParams,
  options: RequestOptions = {}
): Promise<PostDashboardsMemberResult> =>
  request(
    'POST',
    `/api/v2/dashboards/${params.dashboardID}/members`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostDashboardsMemberResult>

export interface DeleteDashboardsMemberParams {
  userID: string
  dashboardID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteDashboardsMemberResult =
  | DeleteDashboardsMemberNoContentResult
  | DeleteDashboardsMemberDefaultResult

interface DeleteDashboardsMemberNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteDashboardsMemberDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteDashboardsMember = (
  params: DeleteDashboardsMemberParams,
  options: RequestOptions = {}
): Promise<DeleteDashboardsMemberResult> =>
  request(
    'DELETE',
    `/api/v2/dashboards/${params.dashboardID}/members/${params.userID}`,
    params,
    options
  ) as Promise<DeleteDashboardsMemberResult>

export interface GetDashboardsOwnersParams {
  dashboardID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetDashboardsOwnersResult =
  | GetDashboardsOwnersOKResult
  | GetDashboardsOwnersDefaultResult

interface GetDashboardsOwnersOKResult {
  status: 200
  headers: Headers
  data: ResourceOwners
}

interface GetDashboardsOwnersDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getDashboardsOwners = (
  params: GetDashboardsOwnersParams,
  options: RequestOptions = {}
): Promise<GetDashboardsOwnersResult> =>
  request(
    'GET',
    `/api/v2/dashboards/${params.dashboardID}/owners`,
    params,
    options
  ) as Promise<GetDashboardsOwnersResult>

export interface PostDashboardsOwnerParams {
  dashboardID: string

  data: AddResourceMemberRequestBody

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostDashboardsOwnerResult =
  | PostDashboardsOwnerCreatedResult
  | PostDashboardsOwnerDefaultResult

interface PostDashboardsOwnerCreatedResult {
  status: 201
  headers: Headers
  data: ResourceOwner
}

interface PostDashboardsOwnerDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postDashboardsOwner = (
  params: PostDashboardsOwnerParams,
  options: RequestOptions = {}
): Promise<PostDashboardsOwnerResult> =>
  request(
    'POST',
    `/api/v2/dashboards/${params.dashboardID}/owners`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostDashboardsOwnerResult>

export interface DeleteDashboardsOwnerParams {
  userID: string
  dashboardID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteDashboardsOwnerResult =
  | DeleteDashboardsOwnerNoContentResult
  | DeleteDashboardsOwnerDefaultResult

interface DeleteDashboardsOwnerNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteDashboardsOwnerDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteDashboardsOwner = (
  params: DeleteDashboardsOwnerParams,
  options: RequestOptions = {}
): Promise<DeleteDashboardsOwnerResult> =>
  request(
    'DELETE',
    `/api/v2/dashboards/${params.dashboardID}/owners/${params.userID}`,
    params,
    options
  ) as Promise<DeleteDashboardsOwnerResult>

export interface PostQueryAstParams {
  data?: LanguageRequest

  headers?: {
    'Zap-Trace-Span'?: string
    'Content-Type'?: string
  }
}

type PostQueryAstResult =
  | PostQueryAstOKResult
  | PostQueryAstBadRequestResult
  | PostQueryAstDefaultResult

interface PostQueryAstOKResult {
  status: 200
  headers: Headers
  data: ASTResponse
}

interface PostQueryAstBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface PostQueryAstDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postQueryAst = (
  params: PostQueryAstParams,
  options: RequestOptions = {}
): Promise<PostQueryAstResult> =>
  request(
    'POST',
    '/api/v2/query/ast',
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostQueryAstResult>

export interface GetQuerySuggestionsParams {
  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetQuerySuggestionsResult =
  | GetQuerySuggestionsOKResult
  | GetQuerySuggestionsDefaultResult

interface GetQuerySuggestionsOKResult {
  status: 200
  headers: Headers
  data: FluxSuggestions
}

interface GetQuerySuggestionsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getQuerySuggestions = (
  params: GetQuerySuggestionsParams,
  options: RequestOptions = {}
): Promise<GetQuerySuggestionsResult> =>
  request('GET', '/api/v2/query/suggestions', params, options) as Promise<
    GetQuerySuggestionsResult
  >

export interface GetQuerySuggestionParams {
  name: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetQuerySuggestionResult =
  | GetQuerySuggestionOKResult
  | GetQuerySuggestionDefaultResult

interface GetQuerySuggestionOKResult {
  status: 200
  headers: Headers
  data: FluxSuggestion
}

interface GetQuerySuggestionDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getQuerySuggestion = (
  params: GetQuerySuggestionParams,
  options: RequestOptions = {}
): Promise<GetQuerySuggestionResult> =>
  request(
    'GET',
    `/api/v2/query/suggestions/${params.name}`,
    params,
    options
  ) as Promise<GetQuerySuggestionResult>

export interface PostQueryAnalyzeParams {
  data?: Query

  headers?: {
    'Zap-Trace-Span'?: string
    'Content-Type'?: string
  }
}

type PostQueryAnalyzeResult =
  | PostQueryAnalyzeOKResult
  | PostQueryAnalyzeBadRequestResult
  | PostQueryAnalyzeDefaultResult

interface PostQueryAnalyzeOKResult {
  status: 200
  headers: Headers
  data: AnalyzeQueryResponse
}

interface PostQueryAnalyzeBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface PostQueryAnalyzeDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postQueryAnalyze = (
  params: PostQueryAnalyzeParams,
  options: RequestOptions = {}
): Promise<PostQueryAnalyzeResult> =>
  request(
    'POST',
    '/api/v2/query/analyze',
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostQueryAnalyzeResult>

export interface PostQueryParams {
  data?: Query

  query?: {
    org?: string
    orgID?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
    'Accept-Encoding'?: string
    'Content-Type'?: string
  }
}

type PostQueryResult =
  | PostQueryOKResult
  | PostQueryBadRequestResult
  | PostQueryUnauthorizedResult
  | PostQueryNotFoundResult
  | PostQueryTooManyRequestsResult
  | PostQueryInternalServerErrorResult
  | PostQueryDefaultResult

interface PostQueryOKResult {
  status: 200
  headers: Headers
  data: string
}

interface PostQueryBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface PostQueryUnauthorizedResult {
  status: 401
  headers: Headers
  data: Error
}

interface PostQueryNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface PostQueryTooManyRequestsResult {
  status: 429
  headers: Headers
  data: any
}

interface PostQueryInternalServerErrorResult {
  status: 500
  headers: Headers
  data: Error
}

interface PostQueryDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postQuery = (
  params: PostQueryParams,
  options: RequestOptions = {}
): Promise<PostQueryResult> =>
  request(
    'POST',
    '/api/v2/query',
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostQueryResult>

export interface GetBucketsParams {
  query?: {
    offset?: number
    limit?: number
    after?: string
    org?: string
    orgID?: string
    name?: string
    id?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetBucketsResult = GetBucketsOKResult | GetBucketsDefaultResult

interface GetBucketsOKResult {
  status: 200
  headers: Headers
  data: Buckets
}

interface GetBucketsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getBuckets = (
  params: GetBucketsParams,
  options: RequestOptions = {}
): Promise<GetBucketsResult> =>
  request('GET', '/api/v2/buckets', params, options) as Promise<
    GetBucketsResult
  >

export interface PostBucketParams {
  data: PostBucketRequest

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostBucketResult =
  | PostBucketCreatedResult
  | PostBucketUnprocessableEntityResult
  | PostBucketDefaultResult

interface PostBucketCreatedResult {
  status: 201
  headers: Headers
  data: Bucket
}

interface PostBucketUnprocessableEntityResult {
  status: 422
  headers: Headers
  data: Error
}

interface PostBucketDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postBucket = (
  params: PostBucketParams,
  options: RequestOptions = {}
): Promise<PostBucketResult> =>
  request(
    'POST',
    '/api/v2/buckets',
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostBucketResult>

export interface GetBucketParams {
  bucketID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetBucketResult = GetBucketOKResult | GetBucketDefaultResult

interface GetBucketOKResult {
  status: 200
  headers: Headers
  data: Bucket
}

interface GetBucketDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getBucket = (
  params: GetBucketParams,
  options: RequestOptions = {}
): Promise<GetBucketResult> =>
  request(
    'GET',
    `/api/v2/buckets/${params.bucketID}`,
    params,
    options
  ) as Promise<GetBucketResult>

export interface PatchBucketParams {
  bucketID: string

  data: PatchBucketRequest

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PatchBucketResult = PatchBucketOKResult | PatchBucketDefaultResult

interface PatchBucketOKResult {
  status: 200
  headers: Headers
  data: Bucket
}

interface PatchBucketDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const patchBucket = (
  params: PatchBucketParams,
  options: RequestOptions = {}
): Promise<PatchBucketResult> =>
  request(
    'PATCH',
    `/api/v2/buckets/${params.bucketID}`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PatchBucketResult>

export interface DeleteBucketParams {
  bucketID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteBucketResult =
  | DeleteBucketNoContentResult
  | DeleteBucketNotFoundResult
  | DeleteBucketDefaultResult

interface DeleteBucketNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteBucketNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface DeleteBucketDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteBucket = (
  params: DeleteBucketParams,
  options: RequestOptions = {}
): Promise<DeleteBucketResult> =>
  request(
    'DELETE',
    `/api/v2/buckets/${params.bucketID}`,
    params,
    options
  ) as Promise<DeleteBucketResult>

export interface GetBucketsLabelsParams {
  bucketID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetBucketsLabelsResult =
  | GetBucketsLabelsOKResult
  | GetBucketsLabelsDefaultResult

interface GetBucketsLabelsOKResult {
  status: 200
  headers: Headers
  data: LabelsResponse
}

interface GetBucketsLabelsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getBucketsLabels = (
  params: GetBucketsLabelsParams,
  options: RequestOptions = {}
): Promise<GetBucketsLabelsResult> =>
  request(
    'GET',
    `/api/v2/buckets/${params.bucketID}/labels`,
    params,
    options
  ) as Promise<GetBucketsLabelsResult>

export interface PostBucketsLabelParams {
  bucketID: string

  data: LabelMapping

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostBucketsLabelResult =
  | PostBucketsLabelCreatedResult
  | PostBucketsLabelDefaultResult

interface PostBucketsLabelCreatedResult {
  status: 201
  headers: Headers
  data: LabelResponse
}

interface PostBucketsLabelDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postBucketsLabel = (
  params: PostBucketsLabelParams,
  options: RequestOptions = {}
): Promise<PostBucketsLabelResult> =>
  request(
    'POST',
    `/api/v2/buckets/${params.bucketID}/labels`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostBucketsLabelResult>

export interface DeleteBucketsLabelParams {
  bucketID: string
  labelID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteBucketsLabelResult =
  | DeleteBucketsLabelNoContentResult
  | DeleteBucketsLabelNotFoundResult
  | DeleteBucketsLabelDefaultResult

interface DeleteBucketsLabelNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteBucketsLabelNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface DeleteBucketsLabelDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteBucketsLabel = (
  params: DeleteBucketsLabelParams,
  options: RequestOptions = {}
): Promise<DeleteBucketsLabelResult> =>
  request(
    'DELETE',
    `/api/v2/buckets/${params.bucketID}/labels/${params.labelID}`,
    params,
    options
  ) as Promise<DeleteBucketsLabelResult>

export interface GetBucketsMembersParams {
  bucketID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetBucketsMembersResult =
  | GetBucketsMembersOKResult
  | GetBucketsMembersDefaultResult

interface GetBucketsMembersOKResult {
  status: 200
  headers: Headers
  data: ResourceMembers
}

interface GetBucketsMembersDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getBucketsMembers = (
  params: GetBucketsMembersParams,
  options: RequestOptions = {}
): Promise<GetBucketsMembersResult> =>
  request(
    'GET',
    `/api/v2/buckets/${params.bucketID}/members`,
    params,
    options
  ) as Promise<GetBucketsMembersResult>

export interface PostBucketsMemberParams {
  bucketID: string

  data: AddResourceMemberRequestBody

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostBucketsMemberResult =
  | PostBucketsMemberCreatedResult
  | PostBucketsMemberDefaultResult

interface PostBucketsMemberCreatedResult {
  status: 201
  headers: Headers
  data: ResourceMember
}

interface PostBucketsMemberDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postBucketsMember = (
  params: PostBucketsMemberParams,
  options: RequestOptions = {}
): Promise<PostBucketsMemberResult> =>
  request(
    'POST',
    `/api/v2/buckets/${params.bucketID}/members`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostBucketsMemberResult>

export interface DeleteBucketsMemberParams {
  userID: string
  bucketID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteBucketsMemberResult =
  | DeleteBucketsMemberNoContentResult
  | DeleteBucketsMemberDefaultResult

interface DeleteBucketsMemberNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteBucketsMemberDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteBucketsMember = (
  params: DeleteBucketsMemberParams,
  options: RequestOptions = {}
): Promise<DeleteBucketsMemberResult> =>
  request(
    'DELETE',
    `/api/v2/buckets/${params.bucketID}/members/${params.userID}`,
    params,
    options
  ) as Promise<DeleteBucketsMemberResult>

export interface GetBucketsOwnersParams {
  bucketID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetBucketsOwnersResult =
  | GetBucketsOwnersOKResult
  | GetBucketsOwnersDefaultResult

interface GetBucketsOwnersOKResult {
  status: 200
  headers: Headers
  data: ResourceOwners
}

interface GetBucketsOwnersDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getBucketsOwners = (
  params: GetBucketsOwnersParams,
  options: RequestOptions = {}
): Promise<GetBucketsOwnersResult> =>
  request(
    'GET',
    `/api/v2/buckets/${params.bucketID}/owners`,
    params,
    options
  ) as Promise<GetBucketsOwnersResult>

export interface PostBucketsOwnerParams {
  bucketID: string

  data: AddResourceMemberRequestBody

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostBucketsOwnerResult =
  | PostBucketsOwnerCreatedResult
  | PostBucketsOwnerDefaultResult

interface PostBucketsOwnerCreatedResult {
  status: 201
  headers: Headers
  data: ResourceOwner
}

interface PostBucketsOwnerDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postBucketsOwner = (
  params: PostBucketsOwnerParams,
  options: RequestOptions = {}
): Promise<PostBucketsOwnerResult> =>
  request(
    'POST',
    `/api/v2/buckets/${params.bucketID}/owners`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostBucketsOwnerResult>

export interface DeleteBucketsOwnerParams {
  userID: string
  bucketID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteBucketsOwnerResult =
  | DeleteBucketsOwnerNoContentResult
  | DeleteBucketsOwnerDefaultResult

interface DeleteBucketsOwnerNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteBucketsOwnerDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteBucketsOwner = (
  params: DeleteBucketsOwnerParams,
  options: RequestOptions = {}
): Promise<DeleteBucketsOwnerResult> =>
  request(
    'DELETE',
    `/api/v2/buckets/${params.bucketID}/owners/${params.userID}`,
    params,
    options
  ) as Promise<DeleteBucketsOwnerResult>

export interface GetOrgsParams {
  query?: {
    offset?: number
    limit?: number
    descending?: any
    org?: string
    orgID?: string
    userID?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetOrgsResult = GetOrgsOKResult | GetOrgsDefaultResult

interface GetOrgsOKResult {
  status: 200
  headers: Headers
  data: Organizations
}

interface GetOrgsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getOrgs = (
  params: GetOrgsParams,
  options: RequestOptions = {}
): Promise<GetOrgsResult> =>
  request('GET', '/api/v2/orgs', params, options) as Promise<GetOrgsResult>

export interface PostOrgParams {
  data: PostOrganizationRequest

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostOrgResult = PostOrgCreatedResult | PostOrgDefaultResult

interface PostOrgCreatedResult {
  status: 201
  headers: Headers
  data: Organization
}

interface PostOrgDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postOrg = (
  params: PostOrgParams,
  options: RequestOptions = {}
): Promise<PostOrgResult> =>
  request(
    'POST',
    '/api/v2/orgs',
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostOrgResult>

export interface GetOrgParams {
  orgID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetOrgResult = GetOrgOKResult | GetOrgDefaultResult

interface GetOrgOKResult {
  status: 200
  headers: Headers
  data: Organization
}

interface GetOrgDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getOrg = (
  params: GetOrgParams,
  options: RequestOptions = {}
): Promise<GetOrgResult> =>
  request('GET', `/api/v2/orgs/${params.orgID}`, params, options) as Promise<
    GetOrgResult
  >

export interface PatchOrgParams {
  orgID: string

  data: PatchOrganizationRequest

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PatchOrgResult = PatchOrgOKResult | PatchOrgDefaultResult

interface PatchOrgOKResult {
  status: 200
  headers: Headers
  data: Organization
}

interface PatchOrgDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const patchOrg = (
  params: PatchOrgParams,
  options: RequestOptions = {}
): Promise<PatchOrgResult> =>
  request(
    'PATCH',
    `/api/v2/orgs/${params.orgID}`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PatchOrgResult>

export interface DeleteOrgParams {
  orgID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteOrgResult =
  | DeleteOrgNoContentResult
  | DeleteOrgNotFoundResult
  | DeleteOrgDefaultResult

interface DeleteOrgNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteOrgNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface DeleteOrgDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteOrg = (
  params: DeleteOrgParams,
  options: RequestOptions = {}
): Promise<DeleteOrgResult> =>
  request('DELETE', `/api/v2/orgs/${params.orgID}`, params, options) as Promise<
    DeleteOrgResult
  >

export interface GetOrgsSecretsParams {
  orgID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetOrgsSecretsResult = GetOrgsSecretsOKResult | GetOrgsSecretsDefaultResult

interface GetOrgsSecretsOKResult {
  status: 200
  headers: Headers
  data: SecretKeysResponse
}

interface GetOrgsSecretsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getOrgsSecrets = (
  params: GetOrgsSecretsParams,
  options: RequestOptions = {}
): Promise<GetOrgsSecretsResult> =>
  request(
    'GET',
    `/api/v2/orgs/${params.orgID}/secrets`,
    params,
    options
  ) as Promise<GetOrgsSecretsResult>

export interface PatchOrgsSecretsParams {
  orgID: string

  data: Secrets

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PatchOrgsSecretsResult =
  | PatchOrgsSecretsNoContentResult
  | PatchOrgsSecretsDefaultResult

interface PatchOrgsSecretsNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface PatchOrgsSecretsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const patchOrgsSecrets = (
  params: PatchOrgsSecretsParams,
  options: RequestOptions = {}
): Promise<PatchOrgsSecretsResult> =>
  request(
    'PATCH',
    `/api/v2/orgs/${params.orgID}/secrets`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PatchOrgsSecretsResult>

export interface GetOrgsMembersParams {
  orgID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetOrgsMembersResult =
  | GetOrgsMembersOKResult
  | GetOrgsMembersNotFoundResult
  | GetOrgsMembersDefaultResult

interface GetOrgsMembersOKResult {
  status: 200
  headers: Headers
  data: ResourceMembers
}

interface GetOrgsMembersNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface GetOrgsMembersDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getOrgsMembers = (
  params: GetOrgsMembersParams,
  options: RequestOptions = {}
): Promise<GetOrgsMembersResult> =>
  request(
    'GET',
    `/api/v2/orgs/${params.orgID}/members`,
    params,
    options
  ) as Promise<GetOrgsMembersResult>

export interface PostOrgsMemberParams {
  orgID: string

  data: AddResourceMemberRequestBody

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostOrgsMemberResult =
  | PostOrgsMemberCreatedResult
  | PostOrgsMemberDefaultResult

interface PostOrgsMemberCreatedResult {
  status: 201
  headers: Headers
  data: ResourceMember
}

interface PostOrgsMemberDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postOrgsMember = (
  params: PostOrgsMemberParams,
  options: RequestOptions = {}
): Promise<PostOrgsMemberResult> =>
  request(
    'POST',
    `/api/v2/orgs/${params.orgID}/members`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostOrgsMemberResult>

export interface DeleteOrgsMemberParams {
  userID: string
  orgID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteOrgsMemberResult =
  | DeleteOrgsMemberNoContentResult
  | DeleteOrgsMemberDefaultResult

interface DeleteOrgsMemberNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteOrgsMemberDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteOrgsMember = (
  params: DeleteOrgsMemberParams,
  options: RequestOptions = {}
): Promise<DeleteOrgsMemberResult> =>
  request(
    'DELETE',
    `/api/v2/orgs/${params.orgID}/members/${params.userID}`,
    params,
    options
  ) as Promise<DeleteOrgsMemberResult>

export interface GetOrgsOwnersParams {
  orgID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetOrgsOwnersResult =
  | GetOrgsOwnersOKResult
  | GetOrgsOwnersNotFoundResult
  | GetOrgsOwnersDefaultResult

interface GetOrgsOwnersOKResult {
  status: 200
  headers: Headers
  data: ResourceOwners
}

interface GetOrgsOwnersNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface GetOrgsOwnersDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getOrgsOwners = (
  params: GetOrgsOwnersParams,
  options: RequestOptions = {}
): Promise<GetOrgsOwnersResult> =>
  request(
    'GET',
    `/api/v2/orgs/${params.orgID}/owners`,
    params,
    options
  ) as Promise<GetOrgsOwnersResult>

export interface PostOrgsOwnerParams {
  orgID: string

  data: AddResourceMemberRequestBody

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostOrgsOwnerResult =
  | PostOrgsOwnerCreatedResult
  | PostOrgsOwnerDefaultResult

interface PostOrgsOwnerCreatedResult {
  status: 201
  headers: Headers
  data: ResourceOwner
}

interface PostOrgsOwnerDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postOrgsOwner = (
  params: PostOrgsOwnerParams,
  options: RequestOptions = {}
): Promise<PostOrgsOwnerResult> =>
  request(
    'POST',
    `/api/v2/orgs/${params.orgID}/owners`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostOrgsOwnerResult>

export interface DeleteOrgsOwnerParams {
  userID: string
  orgID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteOrgsOwnerResult =
  | DeleteOrgsOwnerNoContentResult
  | DeleteOrgsOwnerDefaultResult

interface DeleteOrgsOwnerNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteOrgsOwnerDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteOrgsOwner = (
  params: DeleteOrgsOwnerParams,
  options: RequestOptions = {}
): Promise<DeleteOrgsOwnerResult> =>
  request(
    'DELETE',
    `/api/v2/orgs/${params.orgID}/owners/${params.userID}`,
    params,
    options
  ) as Promise<DeleteOrgsOwnerResult>

export interface PostOrgsSecretsDeleteParams {
  orgID: string

  data: SecretKeys

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostOrgsSecretsDeleteResult =
  | PostOrgsSecretsDeleteNoContentResult
  | PostOrgsSecretsDeleteDefaultResult

interface PostOrgsSecretsDeleteNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface PostOrgsSecretsDeleteDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postOrgsSecretsDelete = (
  params: PostOrgsSecretsDeleteParams,
  options: RequestOptions = {}
): Promise<PostOrgsSecretsDeleteResult> =>
  request(
    'POST',
    `/api/v2/orgs/${params.orgID}/secrets/delete`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostOrgsSecretsDeleteResult>

export interface DeleteOrgsSecretParams {
  orgID: string
  secretID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteOrgsSecretResult =
  | DeleteOrgsSecretNoContentResult
  | DeleteOrgsSecretDefaultResult

interface DeleteOrgsSecretNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteOrgsSecretDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteOrgsSecret = (
  params: DeleteOrgsSecretParams,
  options: RequestOptions = {}
): Promise<DeleteOrgsSecretResult> =>
  request(
    'DELETE',
    `/api/v2/orgs/${params.orgID}/secrets/${params.secretID}`,
    params,
    options
  ) as Promise<DeleteOrgsSecretResult>

export interface GetResourcesParams {
  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetResourcesResult = GetResourcesOKResult | GetResourcesDefaultResult

interface GetResourcesOKResult {
  status: 200
  headers: Headers
  data: string[]
}

interface GetResourcesDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getResources = (
  params: GetResourcesParams,
  options: RequestOptions = {}
): Promise<GetResourcesResult> =>
  request('GET', '/api/v2/resources', params, options) as Promise<
    GetResourcesResult
  >

export interface GetStacksParams {
  query: {
    orgID: string
    name?: string
    stackID?: string
  }
}

type GetStacksResult = GetStacksOKResult | GetStacksDefaultResult

interface GetStacksOKResult {
  status: 200
  headers: Headers
  data: {
    stacks?: Stack[]
  }
}

interface GetStacksDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getStacks = (
  params: GetStacksParams,
  options: RequestOptions = {}
): Promise<GetStacksResult> =>
  request('GET', '/api/v2/stacks', params, options) as Promise<GetStacksResult>

export interface PostStackParams {
  data: {
    orgID?: string
    name?: string
    description?: string
    urls?: string[]
  }
}

type PostStackResult = PostStackCreatedResult | PostStackDefaultResult

interface PostStackCreatedResult {
  status: 201
  headers: Headers
  data: Stack
}

interface PostStackDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postStack = (
  params: PostStackParams,
  options: RequestOptions = {}
): Promise<PostStackResult> =>
  request(
    'POST',
    '/api/v2/stacks',
    {...params, headers: {'Content-Type': 'application/json'}},
    options
  ) as Promise<PostStackResult>

export interface GetStackParams {
  stack_id: string
}

type GetStackResult = GetStackOKResult | GetStackDefaultResult

interface GetStackOKResult {
  status: 200
  headers: Headers
  data: Stack
}

interface GetStackDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getStack = (
  params: GetStackParams,
  options: RequestOptions = {}
): Promise<GetStackResult> =>
  request(
    'GET',
    `/api/v2/stacks/${params.stack_id}`,
    params,
    options
  ) as Promise<GetStackResult>

export interface PatchStackParams {
  stack_id: string

  data: {
    name?: string
    description?: string
    templateURLs?: string[]
    additionalResources?: Array<{
      resourceID: string
      kind: string
      templateMetaName?: string
    }>
  }
}

type PatchStackResult = PatchStackOKResult | PatchStackDefaultResult

interface PatchStackOKResult {
  status: 200
  headers: Headers
  data: Stack
}

interface PatchStackDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const patchStack = (
  params: PatchStackParams,
  options: RequestOptions = {}
): Promise<PatchStackResult> =>
  request(
    'PATCH',
    `/api/v2/stacks/${params.stack_id}`,
    {...params, headers: {'Content-Type': 'application/json'}},
    options
  ) as Promise<PatchStackResult>

export interface DeleteStackParams {
  stack_id: string

  query: {
    orgID: string
  }
}

type DeleteStackResult = DeleteStackNoContentResult | DeleteStackDefaultResult

interface DeleteStackNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteStackDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteStack = (
  params: DeleteStackParams,
  options: RequestOptions = {}
): Promise<DeleteStackResult> =>
  request(
    'DELETE',
    `/api/v2/stacks/${params.stack_id}`,
    params,
    options
  ) as Promise<DeleteStackResult>

export interface PostStacksUninstallParams {
  stack_id: string
}

type PostStacksUninstallResult =
  | PostStacksUninstallOKResult
  | PostStacksUninstallDefaultResult

interface PostStacksUninstallOKResult {
  status: 200
  headers: Headers
  data: Stack
}

interface PostStacksUninstallDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postStacksUninstall = (
  params: PostStacksUninstallParams,
  options: RequestOptions = {}
): Promise<PostStacksUninstallResult> =>
  request(
    'POST',
    `/api/v2/stacks/${params.stack_id}/uninstall`,
    params,
    options
  ) as Promise<PostStacksUninstallResult>

export interface PostTemplatesApplyParams {
  data: TemplateApply
}

type PostTemplatesApplyResult =
  | PostTemplatesApplyOKResult
  | PostTemplatesApplyCreatedResult
  | PostTemplatesApplyUnprocessableEntityResult
  | PostTemplatesApplyDefaultResult

interface PostTemplatesApplyOKResult {
  status: 200
  headers: Headers
  data: TemplateSummary
}

interface PostTemplatesApplyCreatedResult {
  status: 201
  headers: Headers
  data: TemplateSummary
}

interface PostTemplatesApplyUnprocessableEntityResult {
  status: 422
  headers: Headers
  data: TemplateSummary & {
    message: string
    code: string
  }
}

interface PostTemplatesApplyDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postTemplatesApply = (
  params: PostTemplatesApplyParams,
  options: RequestOptions = {}
): Promise<PostTemplatesApplyResult> =>
  request(
    'POST',
    '/api/v2/templates/apply',
    {...params, headers: {'Content-Type': 'application/json'}},
    options
  ) as Promise<PostTemplatesApplyResult>

export interface PostTemplatesExportParams {
  data?: TemplateExportByID | TemplateExportByName
}

type PostTemplatesExportResult =
  | PostTemplatesExportOKResult
  | PostTemplatesExportDefaultResult

interface PostTemplatesExportOKResult {
  status: 200
  headers: Headers
  data: Template
}

interface PostTemplatesExportDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postTemplatesExport = (
  params: PostTemplatesExportParams,
  options: RequestOptions = {}
): Promise<PostTemplatesExportResult> =>
  request(
    'POST',
    '/api/v2/templates/export',
    {...params, headers: {'Content-Type': 'application/json'}},
    options
  ) as Promise<PostTemplatesExportResult>

export interface GetTasksRunsParams {
  taskID: string

  query?: {
    after?: string
    limit?: number
    afterTime?: string
    beforeTime?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetTasksRunsResult = GetTasksRunsOKResult | GetTasksRunsDefaultResult

interface GetTasksRunsOKResult {
  status: 200
  headers: Headers
  data: Runs
}

interface GetTasksRunsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getTasksRuns = (
  params: GetTasksRunsParams,
  options: RequestOptions = {}
): Promise<GetTasksRunsResult> =>
  request(
    'GET',
    `/api/v2/tasks/${params.taskID}/runs`,
    params,
    options
  ) as Promise<GetTasksRunsResult>

export interface PostTasksRunParams {
  taskID: string

  data?: RunManually

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostTasksRunResult = PostTasksRunCreatedResult | PostTasksRunDefaultResult

interface PostTasksRunCreatedResult {
  status: 201
  headers: Headers
  data: Run
}

interface PostTasksRunDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postTasksRun = (
  params: PostTasksRunParams,
  options: RequestOptions = {}
): Promise<PostTasksRunResult> =>
  request(
    'POST',
    `/api/v2/tasks/${params.taskID}/runs`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostTasksRunResult>

export interface GetTasksRunParams {
  taskID: string
  runID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetTasksRunResult =
  | GetTasksRunOKResult
  | GetTasksRunBadRequestResult
  | GetTasksRunUnauthorizedResult
  | GetTasksRunNotFoundResult
  | GetTasksRunInternalServerErrorResult
  | GetTasksRunDefaultResult

interface GetTasksRunOKResult {
  status: 200
  headers: Headers
  data: Run
}

interface GetTasksRunBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface GetTasksRunUnauthorizedResult {
  status: 401
  headers: Headers
  data: Error
}

interface GetTasksRunNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface GetTasksRunInternalServerErrorResult {
  status: 500
  headers: Headers
  data: Error
}

interface GetTasksRunDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getTasksRun = (
  params: GetTasksRunParams,
  options: RequestOptions = {}
): Promise<GetTasksRunResult> =>
  request(
    'GET',
    `/api/v2/tasks/${params.taskID}/runs/${params.runID}`,
    params,
    options
  ) as Promise<GetTasksRunResult>

export interface DeleteTasksRunParams {
  taskID: string
  runID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteTasksRunResult =
  | DeleteTasksRunNoContentResult
  | DeleteTasksRunBadRequestResult
  | DeleteTasksRunUnauthorizedResult
  | DeleteTasksRunNotFoundResult
  | DeleteTasksRunMethodNotAllowedResult
  | DeleteTasksRunInternalServerErrorResult
  | DeleteTasksRunDefaultResult

interface DeleteTasksRunNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteTasksRunBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface DeleteTasksRunUnauthorizedResult {
  status: 401
  headers: Headers
  data: Error
}

interface DeleteTasksRunNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface DeleteTasksRunMethodNotAllowedResult {
  status: 405
  headers: Headers
  data: Error
}

interface DeleteTasksRunInternalServerErrorResult {
  status: 500
  headers: Headers
  data: Error
}

interface DeleteTasksRunDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteTasksRun = (
  params: DeleteTasksRunParams,
  options: RequestOptions = {}
): Promise<DeleteTasksRunResult> =>
  request(
    'DELETE',
    `/api/v2/tasks/${params.taskID}/runs/${params.runID}`,
    params,
    options
  ) as Promise<DeleteTasksRunResult>

export interface PostTasksRunsRetryParams {
  taskID: string
  runID: string

  data?: any

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostTasksRunsRetryResult =
  | PostTasksRunsRetryOKResult
  | PostTasksRunsRetryDefaultResult

interface PostTasksRunsRetryOKResult {
  status: 200
  headers: Headers
  data: Run
}

interface PostTasksRunsRetryDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postTasksRunsRetry = (
  params: PostTasksRunsRetryParams,
  options: RequestOptions = {}
): Promise<PostTasksRunsRetryResult> =>
  request(
    'POST',
    `/api/v2/tasks/${params.taskID}/runs/${params.runID}/retry`,
    {
      ...params,
      headers: {
        ...params.headers,
        'Content-Type': 'application/json; charset=utf-8',
      },
    },
    options
  ) as Promise<PostTasksRunsRetryResult>

export interface GetTasksLogsParams {
  taskID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetTasksLogsResult =
  | GetTasksLogsOKResult
  | GetTasksLogsBadRequestResult
  | GetTasksLogsUnauthorizedResult
  | GetTasksLogsNotFoundResult
  | GetTasksLogsInternalServerErrorResult
  | GetTasksLogsDefaultResult

interface GetTasksLogsOKResult {
  status: 200
  headers: Headers
  data: Logs
}

interface GetTasksLogsBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface GetTasksLogsUnauthorizedResult {
  status: 401
  headers: Headers
  data: Error
}

interface GetTasksLogsNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface GetTasksLogsInternalServerErrorResult {
  status: 500
  headers: Headers
  data: Error
}

interface GetTasksLogsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getTasksLogs = (
  params: GetTasksLogsParams,
  options: RequestOptions = {}
): Promise<GetTasksLogsResult> =>
  request(
    'GET',
    `/api/v2/tasks/${params.taskID}/logs`,
    params,
    options
  ) as Promise<GetTasksLogsResult>

export interface GetTasksRunsLogsParams {
  taskID: string
  runID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetTasksRunsLogsResult =
  | GetTasksRunsLogsOKResult
  | GetTasksRunsLogsDefaultResult

interface GetTasksRunsLogsOKResult {
  status: 200
  headers: Headers
  data: Logs
}

interface GetTasksRunsLogsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getTasksRunsLogs = (
  params: GetTasksRunsLogsParams,
  options: RequestOptions = {}
): Promise<GetTasksRunsLogsResult> =>
  request(
    'GET',
    `/api/v2/tasks/${params.taskID}/runs/${params.runID}/logs`,
    params,
    options
  ) as Promise<GetTasksRunsLogsResult>

export interface GetTasksLabelsParams {
  taskID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetTasksLabelsResult =
  | GetTasksLabelsOKResult
  | GetTasksLabelsBadRequestResult
  | GetTasksLabelsUnauthorizedResult
  | GetTasksLabelsNotFoundResult
  | GetTasksLabelsInternalServerErrorResult
  | GetTasksLabelsDefaultResult

interface GetTasksLabelsOKResult {
  status: 200
  headers: Headers
  data: LabelsResponse
}

interface GetTasksLabelsBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface GetTasksLabelsUnauthorizedResult {
  status: 401
  headers: Headers
  data: Error
}

interface GetTasksLabelsNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface GetTasksLabelsInternalServerErrorResult {
  status: 500
  headers: Headers
  data: Error
}

interface GetTasksLabelsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getTasksLabels = (
  params: GetTasksLabelsParams,
  options: RequestOptions = {}
): Promise<GetTasksLabelsResult> =>
  request(
    'GET',
    `/api/v2/tasks/${params.taskID}/labels`,
    params,
    options
  ) as Promise<GetTasksLabelsResult>

export interface PostTasksLabelParams {
  taskID: string

  data: LabelMapping

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostTasksLabelResult =
  | PostTasksLabelCreatedResult
  | PostTasksLabelBadRequestResult
  | PostTasksLabelUnauthorizedResult
  | PostTasksLabelNotFoundResult
  | PostTasksLabelInternalServerErrorResult
  | PostTasksLabelDefaultResult

interface PostTasksLabelCreatedResult {
  status: 201
  headers: Headers
  data: LabelResponse
}

interface PostTasksLabelBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface PostTasksLabelUnauthorizedResult {
  status: 401
  headers: Headers
  data: Error
}

interface PostTasksLabelNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface PostTasksLabelInternalServerErrorResult {
  status: 500
  headers: Headers
  data: Error
}

interface PostTasksLabelDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postTasksLabel = (
  params: PostTasksLabelParams,
  options: RequestOptions = {}
): Promise<PostTasksLabelResult> =>
  request(
    'POST',
    `/api/v2/tasks/${params.taskID}/labels`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostTasksLabelResult>

export interface DeleteTasksLabelParams {
  taskID: string
  labelID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteTasksLabelResult =
  | DeleteTasksLabelNoContentResult
  | DeleteTasksLabelBadRequestResult
  | DeleteTasksLabelUnauthorizedResult
  | DeleteTasksLabelNotFoundResult
  | DeleteTasksLabelInternalServerErrorResult
  | DeleteTasksLabelDefaultResult

interface DeleteTasksLabelNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteTasksLabelBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface DeleteTasksLabelUnauthorizedResult {
  status: 401
  headers: Headers
  data: Error
}

interface DeleteTasksLabelNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface DeleteTasksLabelInternalServerErrorResult {
  status: 500
  headers: Headers
  data: Error
}

interface DeleteTasksLabelDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteTasksLabel = (
  params: DeleteTasksLabelParams,
  options: RequestOptions = {}
): Promise<DeleteTasksLabelResult> =>
  request(
    'DELETE',
    `/api/v2/tasks/${params.taskID}/labels/${params.labelID}`,
    params,
    options
  ) as Promise<DeleteTasksLabelResult>

export interface GetFlagsParams {
  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetFlagsResult = GetFlagsOKResult | GetFlagsDefaultResult

interface GetFlagsOKResult {
  status: 200
  headers: Headers
  data: Flags
}

interface GetFlagsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getFlags = (
  params: GetFlagsParams,
  options: RequestOptions = {}
): Promise<GetFlagsResult> =>
  request('GET', '/api/v2/flags', params, options) as Promise<GetFlagsResult>

export interface GetMeParams {
  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetMeResult =
  | GetMeOKResult
  | GetMeUnauthorizedResult
  | GetMeInternalServerErrorResult
  | GetMeDefaultResult

interface GetMeOKResult {
  status: 200
  headers: Headers
  data: UserResponse
}

interface GetMeUnauthorizedResult {
  status: 401
  headers: Headers
  data: Error
}

interface GetMeInternalServerErrorResult {
  status: 500
  headers: Headers
  data: Error
}

interface GetMeDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getMe = (
  params: GetMeParams,
  options: RequestOptions = {}
): Promise<GetMeResult> =>
  request('GET', '/api/v2/me', params, options) as Promise<GetMeResult>

export interface PutMePasswordParams {
  data: PasswordResetBody

  headers?: {
    'Zap-Trace-Span'?: string
  }

  auth: {
    username: string
    password: string
  }
}

type PutMePasswordResult =
  | PutMePasswordNoContentResult
  | PutMePasswordBadRequestResult
  | PutMePasswordDefaultResult

interface PutMePasswordNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface PutMePasswordBadRequestResult {
  status: 400
  headers: Headers
  data: any
}

interface PutMePasswordDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const putMePassword = (
  params: PutMePasswordParams,
  options: RequestOptions = {}
): Promise<PutMePasswordResult> =>
  request(
    'PUT',
    '/api/v2/me/password',
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PutMePasswordResult>

export interface GetTasksMembersParams {
  taskID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetTasksMembersResult =
  | GetTasksMembersOKResult
  | GetTasksMembersDefaultResult

interface GetTasksMembersOKResult {
  status: 200
  headers: Headers
  data: ResourceMembers
}

interface GetTasksMembersDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getTasksMembers = (
  params: GetTasksMembersParams,
  options: RequestOptions = {}
): Promise<GetTasksMembersResult> =>
  request(
    'GET',
    `/api/v2/tasks/${params.taskID}/members`,
    params,
    options
  ) as Promise<GetTasksMembersResult>

export interface PostTasksMemberParams {
  taskID: string

  data: AddResourceMemberRequestBody

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostTasksMemberResult =
  | PostTasksMemberCreatedResult
  | PostTasksMemberDefaultResult

interface PostTasksMemberCreatedResult {
  status: 201
  headers: Headers
  data: ResourceMember
}

interface PostTasksMemberDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postTasksMember = (
  params: PostTasksMemberParams,
  options: RequestOptions = {}
): Promise<PostTasksMemberResult> =>
  request(
    'POST',
    `/api/v2/tasks/${params.taskID}/members`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostTasksMemberResult>

export interface DeleteTasksMemberParams {
  userID: string
  taskID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteTasksMemberResult =
  | DeleteTasksMemberNoContentResult
  | DeleteTasksMemberDefaultResult

interface DeleteTasksMemberNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteTasksMemberDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteTasksMember = (
  params: DeleteTasksMemberParams,
  options: RequestOptions = {}
): Promise<DeleteTasksMemberResult> =>
  request(
    'DELETE',
    `/api/v2/tasks/${params.taskID}/members/${params.userID}`,
    params,
    options
  ) as Promise<DeleteTasksMemberResult>

export interface GetTasksOwnersParams {
  taskID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetTasksOwnersResult = GetTasksOwnersOKResult | GetTasksOwnersDefaultResult

interface GetTasksOwnersOKResult {
  status: 200
  headers: Headers
  data: ResourceOwners
}

interface GetTasksOwnersDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getTasksOwners = (
  params: GetTasksOwnersParams,
  options: RequestOptions = {}
): Promise<GetTasksOwnersResult> =>
  request(
    'GET',
    `/api/v2/tasks/${params.taskID}/owners`,
    params,
    options
  ) as Promise<GetTasksOwnersResult>

export interface PostTasksOwnerParams {
  taskID: string

  data: AddResourceMemberRequestBody

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostTasksOwnerResult =
  | PostTasksOwnerCreatedResult
  | PostTasksOwnerDefaultResult

interface PostTasksOwnerCreatedResult {
  status: 201
  headers: Headers
  data: ResourceOwner
}

interface PostTasksOwnerDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postTasksOwner = (
  params: PostTasksOwnerParams,
  options: RequestOptions = {}
): Promise<PostTasksOwnerResult> =>
  request(
    'POST',
    `/api/v2/tasks/${params.taskID}/owners`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostTasksOwnerResult>

export interface DeleteTasksOwnerParams {
  userID: string
  taskID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteTasksOwnerResult =
  | DeleteTasksOwnerNoContentResult
  | DeleteTasksOwnerDefaultResult

interface DeleteTasksOwnerNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteTasksOwnerDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteTasksOwner = (
  params: DeleteTasksOwnerParams,
  options: RequestOptions = {}
): Promise<DeleteTasksOwnerResult> =>
  request(
    'DELETE',
    `/api/v2/tasks/${params.taskID}/owners/${params.userID}`,
    params,
    options
  ) as Promise<DeleteTasksOwnerResult>

export interface PostUsersPasswordParams {
  userID: string

  data: PasswordResetBody

  headers?: {
    'Zap-Trace-Span'?: string
  }

  auth: {
    username: string
    password: string
  }
}

type PostUsersPasswordResult =
  | PostUsersPasswordNoContentResult
  | PostUsersPasswordBadRequestResult
  | PostUsersPasswordDefaultResult

interface PostUsersPasswordNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface PostUsersPasswordBadRequestResult {
  status: 400
  headers: Headers
  data: any
}

interface PostUsersPasswordDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postUsersPassword = (
  params: PostUsersPasswordParams,
  options: RequestOptions = {}
): Promise<PostUsersPasswordResult> =>
  request(
    'POST',
    `/api/v2/users/${params.userID}/password`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostUsersPasswordResult>

export interface GetChecksParams {
  query: {
    offset?: number
    limit?: number
    orgID: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetChecksResult = GetChecksOKResult | GetChecksDefaultResult

interface GetChecksOKResult {
  status: 200
  headers: Headers
  data: Checks
}

interface GetChecksDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getChecks = (
  params: GetChecksParams,
  options: RequestOptions = {}
): Promise<GetChecksResult> =>
  request('GET', '/api/v2/checks', params, options) as Promise<GetChecksResult>

export interface PostCheckParams {
  data: PostCheck
}

type PostCheckResult = PostCheckCreatedResult | PostCheckDefaultResult

interface PostCheckCreatedResult {
  status: 201
  headers: Headers
  data: Check
}

interface PostCheckDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postCheck = (
  params: PostCheckParams,
  options: RequestOptions = {}
): Promise<PostCheckResult> =>
  request(
    'POST',
    '/api/v2/checks',
    {...params, headers: {'Content-Type': 'application/json'}},
    options
  ) as Promise<PostCheckResult>

export interface GetCheckParams {
  checkID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetCheckResult = GetCheckOKResult | GetCheckDefaultResult

interface GetCheckOKResult {
  status: 200
  headers: Headers
  data: Check
}

interface GetCheckDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getCheck = (
  params: GetCheckParams,
  options: RequestOptions = {}
): Promise<GetCheckResult> =>
  request(
    'GET',
    `/api/v2/checks/${params.checkID}`,
    params,
    options
  ) as Promise<GetCheckResult>

export interface PutCheckParams {
  checkID: string

  data: Check

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PutCheckResult =
  | PutCheckOKResult
  | PutCheckNotFoundResult
  | PutCheckDefaultResult

interface PutCheckOKResult {
  status: 200
  headers: Headers
  data: Check
}

interface PutCheckNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface PutCheckDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const putCheck = (
  params: PutCheckParams,
  options: RequestOptions = {}
): Promise<PutCheckResult> =>
  request(
    'PUT',
    `/api/v2/checks/${params.checkID}`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PutCheckResult>

export interface PatchCheckParams {
  checkID: string

  data: CheckPatch

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PatchCheckResult =
  | PatchCheckOKResult
  | PatchCheckNotFoundResult
  | PatchCheckDefaultResult

interface PatchCheckOKResult {
  status: 200
  headers: Headers
  data: Check
}

interface PatchCheckNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface PatchCheckDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const patchCheck = (
  params: PatchCheckParams,
  options: RequestOptions = {}
): Promise<PatchCheckResult> =>
  request(
    'PATCH',
    `/api/v2/checks/${params.checkID}`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PatchCheckResult>

export interface DeleteCheckParams {
  checkID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteCheckResult =
  | DeleteCheckNoContentResult
  | DeleteCheckNotFoundResult
  | DeleteCheckDefaultResult

interface DeleteCheckNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteCheckNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface DeleteCheckDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteCheck = (
  params: DeleteCheckParams,
  options: RequestOptions = {}
): Promise<DeleteCheckResult> =>
  request(
    'DELETE',
    `/api/v2/checks/${params.checkID}`,
    params,
    options
  ) as Promise<DeleteCheckResult>

export interface GetChecksLabelsParams {
  checkID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetChecksLabelsResult =
  | GetChecksLabelsOKResult
  | GetChecksLabelsDefaultResult

interface GetChecksLabelsOKResult {
  status: 200
  headers: Headers
  data: LabelsResponse
}

interface GetChecksLabelsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getChecksLabels = (
  params: GetChecksLabelsParams,
  options: RequestOptions = {}
): Promise<GetChecksLabelsResult> =>
  request(
    'GET',
    `/api/v2/checks/${params.checkID}/labels`,
    params,
    options
  ) as Promise<GetChecksLabelsResult>

export interface PostChecksLabelParams {
  checkID: string

  data: LabelMapping

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostChecksLabelResult =
  | PostChecksLabelCreatedResult
  | PostChecksLabelDefaultResult

interface PostChecksLabelCreatedResult {
  status: 201
  headers: Headers
  data: LabelResponse
}

interface PostChecksLabelDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postChecksLabel = (
  params: PostChecksLabelParams,
  options: RequestOptions = {}
): Promise<PostChecksLabelResult> =>
  request(
    'POST',
    `/api/v2/checks/${params.checkID}/labels`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostChecksLabelResult>

export interface DeleteChecksLabelParams {
  checkID: string
  labelID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteChecksLabelResult =
  | DeleteChecksLabelNoContentResult
  | DeleteChecksLabelNotFoundResult
  | DeleteChecksLabelDefaultResult

interface DeleteChecksLabelNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteChecksLabelNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface DeleteChecksLabelDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteChecksLabel = (
  params: DeleteChecksLabelParams,
  options: RequestOptions = {}
): Promise<DeleteChecksLabelResult> =>
  request(
    'DELETE',
    `/api/v2/checks/${params.checkID}/labels/${params.labelID}`,
    params,
    options
  ) as Promise<DeleteChecksLabelResult>

export interface GetNotificationRulesParams {
  query: {
    offset?: number
    limit?: number
    orgID: string
    checkID?: string
    tag?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetNotificationRulesResult =
  | GetNotificationRulesOKResult
  | GetNotificationRulesDefaultResult

interface GetNotificationRulesOKResult {
  status: 200
  headers: Headers
  data: NotificationRules
}

interface GetNotificationRulesDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getNotificationRules = (
  params: GetNotificationRulesParams,
  options: RequestOptions = {}
): Promise<GetNotificationRulesResult> =>
  request('GET', '/api/v2/notificationRules', params, options) as Promise<
    GetNotificationRulesResult
  >

export interface PostNotificationRuleParams {
  data: PostNotificationRule
}

type PostNotificationRuleResult =
  | PostNotificationRuleCreatedResult
  | PostNotificationRuleDefaultResult

interface PostNotificationRuleCreatedResult {
  status: 201
  headers: Headers
  data: NotificationRule
}

interface PostNotificationRuleDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postNotificationRule = (
  params: PostNotificationRuleParams,
  options: RequestOptions = {}
): Promise<PostNotificationRuleResult> =>
  request(
    'POST',
    '/api/v2/notificationRules',
    {...params, headers: {'Content-Type': 'application/json'}},
    options
  ) as Promise<PostNotificationRuleResult>

export interface GetChecksQueryParams {
  checkID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetChecksQueryResult =
  | GetChecksQueryOKResult
  | GetChecksQueryBadRequestResult
  | GetChecksQueryNotFoundResult
  | GetChecksQueryDefaultResult

interface GetChecksQueryOKResult {
  status: 200
  headers: Headers
  data: FluxResponse
}

interface GetChecksQueryBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface GetChecksQueryNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface GetChecksQueryDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getChecksQuery = (
  params: GetChecksQueryParams,
  options: RequestOptions = {}
): Promise<GetChecksQueryResult> =>
  request(
    'GET',
    `/api/v2/checks/${params.checkID}/query`,
    params,
    options
  ) as Promise<GetChecksQueryResult>

export interface GetNotificationRuleParams {
  ruleID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetNotificationRuleResult =
  | GetNotificationRuleOKResult
  | GetNotificationRuleDefaultResult

interface GetNotificationRuleOKResult {
  status: 200
  headers: Headers
  data: NotificationRule
}

interface GetNotificationRuleDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getNotificationRule = (
  params: GetNotificationRuleParams,
  options: RequestOptions = {}
): Promise<GetNotificationRuleResult> =>
  request(
    'GET',
    `/api/v2/notificationRules/${params.ruleID}`,
    params,
    options
  ) as Promise<GetNotificationRuleResult>

export interface PutNotificationRuleParams {
  ruleID: string

  data: NotificationRule

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PutNotificationRuleResult =
  | PutNotificationRuleOKResult
  | PutNotificationRuleNotFoundResult
  | PutNotificationRuleDefaultResult

interface PutNotificationRuleOKResult {
  status: 200
  headers: Headers
  data: NotificationRule
}

interface PutNotificationRuleNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface PutNotificationRuleDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const putNotificationRule = (
  params: PutNotificationRuleParams,
  options: RequestOptions = {}
): Promise<PutNotificationRuleResult> =>
  request(
    'PUT',
    `/api/v2/notificationRules/${params.ruleID}`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PutNotificationRuleResult>

export interface PatchNotificationRuleParams {
  ruleID: string

  data: NotificationRuleUpdate

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PatchNotificationRuleResult =
  | PatchNotificationRuleOKResult
  | PatchNotificationRuleNotFoundResult
  | PatchNotificationRuleDefaultResult

interface PatchNotificationRuleOKResult {
  status: 200
  headers: Headers
  data: NotificationRule
}

interface PatchNotificationRuleNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface PatchNotificationRuleDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const patchNotificationRule = (
  params: PatchNotificationRuleParams,
  options: RequestOptions = {}
): Promise<PatchNotificationRuleResult> =>
  request(
    'PATCH',
    `/api/v2/notificationRules/${params.ruleID}`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PatchNotificationRuleResult>

export interface DeleteNotificationRuleParams {
  ruleID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteNotificationRuleResult =
  | DeleteNotificationRuleNoContentResult
  | DeleteNotificationRuleNotFoundResult
  | DeleteNotificationRuleDefaultResult

interface DeleteNotificationRuleNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteNotificationRuleNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface DeleteNotificationRuleDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteNotificationRule = (
  params: DeleteNotificationRuleParams,
  options: RequestOptions = {}
): Promise<DeleteNotificationRuleResult> =>
  request(
    'DELETE',
    `/api/v2/notificationRules/${params.ruleID}`,
    params,
    options
  ) as Promise<DeleteNotificationRuleResult>

export interface GetNotificationRulesLabelsParams {
  ruleID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetNotificationRulesLabelsResult =
  | GetNotificationRulesLabelsOKResult
  | GetNotificationRulesLabelsDefaultResult

interface GetNotificationRulesLabelsOKResult {
  status: 200
  headers: Headers
  data: LabelsResponse
}

interface GetNotificationRulesLabelsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getNotificationRulesLabels = (
  params: GetNotificationRulesLabelsParams,
  options: RequestOptions = {}
): Promise<GetNotificationRulesLabelsResult> =>
  request(
    'GET',
    `/api/v2/notificationRules/${params.ruleID}/labels`,
    params,
    options
  ) as Promise<GetNotificationRulesLabelsResult>

export interface PostNotificationRulesLabelParams {
  ruleID: string

  data: LabelMapping

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostNotificationRulesLabelResult =
  | PostNotificationRulesLabelCreatedResult
  | PostNotificationRulesLabelDefaultResult

interface PostNotificationRulesLabelCreatedResult {
  status: 201
  headers: Headers
  data: LabelResponse
}

interface PostNotificationRulesLabelDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postNotificationRulesLabel = (
  params: PostNotificationRulesLabelParams,
  options: RequestOptions = {}
): Promise<PostNotificationRulesLabelResult> =>
  request(
    'POST',
    `/api/v2/notificationRules/${params.ruleID}/labels`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostNotificationRulesLabelResult>

export interface DeleteNotificationRulesLabelParams {
  ruleID: string
  labelID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteNotificationRulesLabelResult =
  | DeleteNotificationRulesLabelNoContentResult
  | DeleteNotificationRulesLabelNotFoundResult
  | DeleteNotificationRulesLabelDefaultResult

interface DeleteNotificationRulesLabelNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteNotificationRulesLabelNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface DeleteNotificationRulesLabelDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteNotificationRulesLabel = (
  params: DeleteNotificationRulesLabelParams,
  options: RequestOptions = {}
): Promise<DeleteNotificationRulesLabelResult> =>
  request(
    'DELETE',
    `/api/v2/notificationRules/${params.ruleID}/labels/${params.labelID}`,
    params,
    options
  ) as Promise<DeleteNotificationRulesLabelResult>

export interface GetNotificationRulesQueryParams {
  ruleID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetNotificationRulesQueryResult =
  | GetNotificationRulesQueryOKResult
  | GetNotificationRulesQueryBadRequestResult
  | GetNotificationRulesQueryNotFoundResult
  | GetNotificationRulesQueryDefaultResult

interface GetNotificationRulesQueryOKResult {
  status: 200
  headers: Headers
  data: FluxResponse
}

interface GetNotificationRulesQueryBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface GetNotificationRulesQueryNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface GetNotificationRulesQueryDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getNotificationRulesQuery = (
  params: GetNotificationRulesQueryParams,
  options: RequestOptions = {}
): Promise<GetNotificationRulesQueryResult> =>
  request(
    'GET',
    `/api/v2/notificationRules/${params.ruleID}/query`,
    params,
    options
  ) as Promise<GetNotificationRulesQueryResult>

export interface GetNotificationEndpointsParams {
  query: {
    offset?: number
    limit?: number
    orgID: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetNotificationEndpointsResult =
  | GetNotificationEndpointsOKResult
  | GetNotificationEndpointsDefaultResult

interface GetNotificationEndpointsOKResult {
  status: 200
  headers: Headers
  data: NotificationEndpoints
}

interface GetNotificationEndpointsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getNotificationEndpoints = (
  params: GetNotificationEndpointsParams,
  options: RequestOptions = {}
): Promise<GetNotificationEndpointsResult> =>
  request('GET', '/api/v2/notificationEndpoints', params, options) as Promise<
    GetNotificationEndpointsResult
  >

export interface PostNotificationEndpointParams {
  data: PostNotificationEndpoint
}

type PostNotificationEndpointResult =
  | PostNotificationEndpointCreatedResult
  | PostNotificationEndpointDefaultResult

interface PostNotificationEndpointCreatedResult {
  status: 201
  headers: Headers
  data: NotificationEndpoint
}

interface PostNotificationEndpointDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postNotificationEndpoint = (
  params: PostNotificationEndpointParams,
  options: RequestOptions = {}
): Promise<PostNotificationEndpointResult> =>
  request(
    'POST',
    '/api/v2/notificationEndpoints',
    {...params, headers: {'Content-Type': 'application/json'}},
    options
  ) as Promise<PostNotificationEndpointResult>

export interface GetNotificationEndpointParams {
  endpointID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetNotificationEndpointResult =
  | GetNotificationEndpointOKResult
  | GetNotificationEndpointDefaultResult

interface GetNotificationEndpointOKResult {
  status: 200
  headers: Headers
  data: NotificationEndpoint
}

interface GetNotificationEndpointDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getNotificationEndpoint = (
  params: GetNotificationEndpointParams,
  options: RequestOptions = {}
): Promise<GetNotificationEndpointResult> =>
  request(
    'GET',
    `/api/v2/notificationEndpoints/${params.endpointID}`,
    params,
    options
  ) as Promise<GetNotificationEndpointResult>

export interface PutNotificationEndpointParams {
  endpointID: string

  data: NotificationEndpoint

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PutNotificationEndpointResult =
  | PutNotificationEndpointOKResult
  | PutNotificationEndpointNotFoundResult
  | PutNotificationEndpointDefaultResult

interface PutNotificationEndpointOKResult {
  status: 200
  headers: Headers
  data: NotificationEndpoint
}

interface PutNotificationEndpointNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface PutNotificationEndpointDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const putNotificationEndpoint = (
  params: PutNotificationEndpointParams,
  options: RequestOptions = {}
): Promise<PutNotificationEndpointResult> =>
  request(
    'PUT',
    `/api/v2/notificationEndpoints/${params.endpointID}`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PutNotificationEndpointResult>

export interface PatchNotificationEndpointParams {
  endpointID: string

  data: NotificationEndpointUpdate

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PatchNotificationEndpointResult =
  | PatchNotificationEndpointOKResult
  | PatchNotificationEndpointNotFoundResult
  | PatchNotificationEndpointDefaultResult

interface PatchNotificationEndpointOKResult {
  status: 200
  headers: Headers
  data: NotificationEndpoint
}

interface PatchNotificationEndpointNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface PatchNotificationEndpointDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const patchNotificationEndpoint = (
  params: PatchNotificationEndpointParams,
  options: RequestOptions = {}
): Promise<PatchNotificationEndpointResult> =>
  request(
    'PATCH',
    `/api/v2/notificationEndpoints/${params.endpointID}`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PatchNotificationEndpointResult>

export interface DeleteNotificationEndpointParams {
  endpointID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteNotificationEndpointResult =
  | DeleteNotificationEndpointNoContentResult
  | DeleteNotificationEndpointNotFoundResult
  | DeleteNotificationEndpointDefaultResult

interface DeleteNotificationEndpointNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteNotificationEndpointNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface DeleteNotificationEndpointDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteNotificationEndpoint = (
  params: DeleteNotificationEndpointParams,
  options: RequestOptions = {}
): Promise<DeleteNotificationEndpointResult> =>
  request(
    'DELETE',
    `/api/v2/notificationEndpoints/${params.endpointID}`,
    params,
    options
  ) as Promise<DeleteNotificationEndpointResult>

export interface GetNotificationEndpointsLabelsParams {
  endpointID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetNotificationEndpointsLabelsResult =
  | GetNotificationEndpointsLabelsOKResult
  | GetNotificationEndpointsLabelsDefaultResult

interface GetNotificationEndpointsLabelsOKResult {
  status: 200
  headers: Headers
  data: LabelsResponse
}

interface GetNotificationEndpointsLabelsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getNotificationEndpointsLabels = (
  params: GetNotificationEndpointsLabelsParams,
  options: RequestOptions = {}
): Promise<GetNotificationEndpointsLabelsResult> =>
  request(
    'GET',
    `/api/v2/notificationEndpoints/${params.endpointID}/labels`,
    params,
    options
  ) as Promise<GetNotificationEndpointsLabelsResult>

export interface PostNotificationEndpointsLabelParams {
  endpointID: string

  data: LabelMapping

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostNotificationEndpointsLabelResult =
  | PostNotificationEndpointsLabelCreatedResult
  | PostNotificationEndpointsLabelDefaultResult

interface PostNotificationEndpointsLabelCreatedResult {
  status: 201
  headers: Headers
  data: LabelResponse
}

interface PostNotificationEndpointsLabelDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postNotificationEndpointsLabel = (
  params: PostNotificationEndpointsLabelParams,
  options: RequestOptions = {}
): Promise<PostNotificationEndpointsLabelResult> =>
  request(
    'POST',
    `/api/v2/notificationEndpoints/${params.endpointID}/labels`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostNotificationEndpointsLabelResult>

export interface DeleteNotificationEndpointsLabelParams {
  endpointID: string
  labelID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteNotificationEndpointsLabelResult =
  | DeleteNotificationEndpointsLabelNoContentResult
  | DeleteNotificationEndpointsLabelNotFoundResult
  | DeleteNotificationEndpointsLabelDefaultResult

interface DeleteNotificationEndpointsLabelNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteNotificationEndpointsLabelNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface DeleteNotificationEndpointsLabelDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteNotificationEndpointsLabel = (
  params: DeleteNotificationEndpointsLabelParams,
  options: RequestOptions = {}
): Promise<DeleteNotificationEndpointsLabelResult> =>
  request(
    'DELETE',
    `/api/v2/notificationEndpoints/${params.endpointID}/labels/${params.labelID}`,
    params,
    options
  ) as Promise<DeleteNotificationEndpointsLabelResult>

export interface GetDebugPprofAllParams {
  query?: {
    cpu?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetDebugPprofAllResult =
  | GetDebugPprofAllOKResult
  | GetDebugPprofAllDefaultResult

interface GetDebugPprofAllOKResult {
  status: 200
  headers: Headers
  data: string
}

interface GetDebugPprofAllDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getDebugPprofAll = (
  params: GetDebugPprofAllParams,
  options: RequestOptions = {}
): Promise<GetDebugPprofAllResult> =>
  request('GET', '/api/v2/debug/pprof/all', params, options) as Promise<
    GetDebugPprofAllResult
  >

export interface GetDebugPprofAllocsParams {
  query?: {
    debug?: number
    seconds?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetDebugPprofAllocsResult =
  | GetDebugPprofAllocsOKResult
  | GetDebugPprofAllocsDefaultResult

interface GetDebugPprofAllocsOKResult {
  status: 200
  headers: Headers
  data: string
}

interface GetDebugPprofAllocsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getDebugPprofAllocs = (
  params: GetDebugPprofAllocsParams,
  options: RequestOptions = {}
): Promise<GetDebugPprofAllocsResult> =>
  request('GET', '/api/v2/debug/pprof/allocs', params, options) as Promise<
    GetDebugPprofAllocsResult
  >

export interface GetDebugPprofBlockParams {
  query?: {
    debug?: number
    seconds?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetDebugPprofBlockResult =
  | GetDebugPprofBlockOKResult
  | GetDebugPprofBlockDefaultResult

interface GetDebugPprofBlockOKResult {
  status: 200
  headers: Headers
  data: string
}

interface GetDebugPprofBlockDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getDebugPprofBlock = (
  params: GetDebugPprofBlockParams,
  options: RequestOptions = {}
): Promise<GetDebugPprofBlockResult> =>
  request('GET', '/api/v2/debug/pprof/block', params, options) as Promise<
    GetDebugPprofBlockResult
  >

export interface GetDebugPprofCmdlineParams {
  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetDebugPprofCmdlineResult =
  | GetDebugPprofCmdlineOKResult
  | GetDebugPprofCmdlineDefaultResult

interface GetDebugPprofCmdlineOKResult {
  status: 200
  headers: Headers
  data: string
}

interface GetDebugPprofCmdlineDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getDebugPprofCmdline = (
  params: GetDebugPprofCmdlineParams,
  options: RequestOptions = {}
): Promise<GetDebugPprofCmdlineResult> =>
  request('GET', '/api/v2/debug/pprof/cmdline', params, options) as Promise<
    GetDebugPprofCmdlineResult
  >

export interface GetDebugPprofGoroutineParams {
  query?: {
    debug?: number
    seconds?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetDebugPprofGoroutineResult =
  | GetDebugPprofGoroutineOKResult
  | GetDebugPprofGoroutineDefaultResult

interface GetDebugPprofGoroutineOKResult {
  status: 200
  headers: Headers
  data: string
}

interface GetDebugPprofGoroutineDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getDebugPprofGoroutine = (
  params: GetDebugPprofGoroutineParams,
  options: RequestOptions = {}
): Promise<GetDebugPprofGoroutineResult> =>
  request('GET', '/api/v2/debug/pprof/goroutine', params, options) as Promise<
    GetDebugPprofGoroutineResult
  >

export interface GetDebugPprofHeapParams {
  query?: {
    debug?: number
    seconds?: string
    gc?: number
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetDebugPprofHeapResult =
  | GetDebugPprofHeapOKResult
  | GetDebugPprofHeapDefaultResult

interface GetDebugPprofHeapOKResult {
  status: 200
  headers: Headers
  data: string
}

interface GetDebugPprofHeapDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getDebugPprofHeap = (
  params: GetDebugPprofHeapParams,
  options: RequestOptions = {}
): Promise<GetDebugPprofHeapResult> =>
  request('GET', '/api/v2/debug/pprof/heap', params, options) as Promise<
    GetDebugPprofHeapResult
  >

export interface GetDebugPprofMutexParams {
  query?: {
    debug?: number
    seconds?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetDebugPprofMutexResult =
  | GetDebugPprofMutexOKResult
  | GetDebugPprofMutexDefaultResult

interface GetDebugPprofMutexOKResult {
  status: 200
  headers: Headers
  data: string
}

interface GetDebugPprofMutexDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getDebugPprofMutex = (
  params: GetDebugPprofMutexParams,
  options: RequestOptions = {}
): Promise<GetDebugPprofMutexResult> =>
  request('GET', '/api/v2/debug/pprof/mutex', params, options) as Promise<
    GetDebugPprofMutexResult
  >

export interface GetDebugPprofProfileParams {
  query?: {
    seconds?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetDebugPprofProfileResult =
  | GetDebugPprofProfileOKResult
  | GetDebugPprofProfileDefaultResult

interface GetDebugPprofProfileOKResult {
  status: 200
  headers: Headers
  data: string
}

interface GetDebugPprofProfileDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getDebugPprofProfile = (
  params: GetDebugPprofProfileParams,
  options: RequestOptions = {}
): Promise<GetDebugPprofProfileResult> =>
  request('GET', '/api/v2/debug/pprof/profile', params, options) as Promise<
    GetDebugPprofProfileResult
  >

export interface GetDebugPprofThreadcreateParams {
  query?: {
    debug?: number
    seconds?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetDebugPprofThreadcreateResult =
  | GetDebugPprofThreadcreateOKResult
  | GetDebugPprofThreadcreateDefaultResult

interface GetDebugPprofThreadcreateOKResult {
  status: 200
  headers: Headers
  data: string
}

interface GetDebugPprofThreadcreateDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getDebugPprofThreadcreate = (
  params: GetDebugPprofThreadcreateParams,
  options: RequestOptions = {}
): Promise<GetDebugPprofThreadcreateResult> =>
  request(
    'GET',
    '/api/v2/debug/pprof/threadcreate',
    params,
    options
  ) as Promise<GetDebugPprofThreadcreateResult>

export interface GetDebugPprofTraceParams {
  query?: {
    seconds?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetDebugPprofTraceResult =
  | GetDebugPprofTraceOKResult
  | GetDebugPprofTraceDefaultResult

interface GetDebugPprofTraceOKResult {
  status: 200
  headers: Headers
  data: string
}

interface GetDebugPprofTraceDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getDebugPprofTrace = (
  params: GetDebugPprofTraceParams,
  options: RequestOptions = {}
): Promise<GetDebugPprofTraceResult> =>
  request('GET', '/api/v2/debug/pprof/trace', params, options) as Promise<
    GetDebugPprofTraceResult
  >

export interface GetHealthParams {
  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetHealthResult =
  | GetHealthOKResult
  | GetHealthServiceUnavailableResult
  | GetHealthDefaultResult

interface GetHealthOKResult {
  status: 200
  headers: Headers
  data: HealthCheck
}

interface GetHealthServiceUnavailableResult {
  status: 503
  headers: Headers
  data: HealthCheck
}

interface GetHealthDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getHealth = (
  params: GetHealthParams,
  options: RequestOptions = {}
): Promise<GetHealthResult> =>
  request('GET', '/api/v2/health', params, options) as Promise<GetHealthResult>

export interface GetMetricsParams {
  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetMetricsResult = GetMetricsOKResult | GetMetricsDefaultResult

interface GetMetricsOKResult {
  status: 200
  headers: Headers
  data: string
}

interface GetMetricsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getMetrics = (
  params: GetMetricsParams,
  options: RequestOptions = {}
): Promise<GetMetricsResult> =>
  request('GET', '/api/v2/metrics', params, options) as Promise<
    GetMetricsResult
  >

export interface GetReadyParams {
  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetReadyResult = GetReadyOKResult | GetReadyDefaultResult

interface GetReadyOKResult {
  status: 200
  headers: Headers
  data: Ready
}

interface GetReadyDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getReady = (
  params: GetReadyParams,
  options: RequestOptions = {}
): Promise<GetReadyResult> =>
  request('GET', '/api/v2/ready', params, options) as Promise<GetReadyResult>

export interface GetUsersParams {
  query?: {
    offset?: number
    limit?: number
    after?: string
    name?: string
    id?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetUsersResult = GetUsersOKResult | GetUsersDefaultResult

interface GetUsersOKResult {
  status: 200
  headers: Headers
  data: Users
}

interface GetUsersDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getUsers = (
  params: GetUsersParams,
  options: RequestOptions = {}
): Promise<GetUsersResult> =>
  request('GET', '/api/v2/users', params, options) as Promise<GetUsersResult>

export interface PostUserParams {
  data: User

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostUserResult = PostUserCreatedResult | PostUserDefaultResult

interface PostUserCreatedResult {
  status: 201
  headers: Headers
  data: UserResponse
}

interface PostUserDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postUser = (
  params: PostUserParams,
  options: RequestOptions = {}
): Promise<PostUserResult> =>
  request(
    'POST',
    '/api/v2/users',
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostUserResult>

export interface GetUserParams {
  userID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetUserResult = GetUserOKResult | GetUserDefaultResult

interface GetUserOKResult {
  status: 200
  headers: Headers
  data: UserResponse
}

interface GetUserDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getUser = (
  params: GetUserParams,
  options: RequestOptions = {}
): Promise<GetUserResult> =>
  request('GET', `/api/v2/users/${params.userID}`, params, options) as Promise<
    GetUserResult
  >

export interface PatchUserParams {
  userID: string

  data: User

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PatchUserResult = PatchUserOKResult | PatchUserDefaultResult

interface PatchUserOKResult {
  status: 200
  headers: Headers
  data: UserResponse
}

interface PatchUserDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const patchUser = (
  params: PatchUserParams,
  options: RequestOptions = {}
): Promise<PatchUserResult> =>
  request(
    'PATCH',
    `/api/v2/users/${params.userID}`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PatchUserResult>

export interface DeleteUserParams {
  userID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteUserResult = DeleteUserNoContentResult | DeleteUserDefaultResult

interface DeleteUserNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteUserDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteUser = (
  params: DeleteUserParams,
  options: RequestOptions = {}
): Promise<DeleteUserResult> =>
  request(
    'DELETE',
    `/api/v2/users/${params.userID}`,
    params,
    options
  ) as Promise<DeleteUserResult>

export interface GetSetupParams {
  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetSetupResult = GetSetupOKResult

interface GetSetupOKResult {
  status: 200
  headers: Headers
  data: IsOnboarding
}

export const getSetup = (
  params: GetSetupParams,
  options: RequestOptions = {}
): Promise<GetSetupResult> =>
  request('GET', '/api/v2/setup', params, options) as Promise<GetSetupResult>

export interface PostSetupParams {
  data: OnboardingRequest

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostSetupResult = PostSetupCreatedResult | PostSetupDefaultResult

interface PostSetupCreatedResult {
  status: 201
  headers: Headers
  data: OnboardingResponse
}

interface PostSetupDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postSetup = (
  params: PostSetupParams,
  options: RequestOptions = {}
): Promise<PostSetupResult> =>
  request(
    'POST',
    '/api/v2/setup',
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostSetupResult>

export interface GetAuthorizationsParams {
  query?: {
    userID?: string
    user?: string
    orgID?: string
    org?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetAuthorizationsResult =
  | GetAuthorizationsOKResult
  | GetAuthorizationsDefaultResult

interface GetAuthorizationsOKResult {
  status: 200
  headers: Headers
  data: Authorizations
}

interface GetAuthorizationsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getAuthorizations = (
  params: GetAuthorizationsParams,
  options: RequestOptions = {}
): Promise<GetAuthorizationsResult> =>
  request('GET', '/api/v2/authorizations', params, options) as Promise<
    GetAuthorizationsResult
  >

export interface PostAuthorizationParams {
  data: AuthorizationPostRequest

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostAuthorizationResult =
  | PostAuthorizationCreatedResult
  | PostAuthorizationBadRequestResult
  | PostAuthorizationDefaultResult

interface PostAuthorizationCreatedResult {
  status: 201
  headers: Headers
  data: Authorization
}

interface PostAuthorizationBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface PostAuthorizationDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postAuthorization = (
  params: PostAuthorizationParams,
  options: RequestOptions = {}
): Promise<PostAuthorizationResult> =>
  request(
    'POST',
    '/api/v2/authorizations',
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostAuthorizationResult>

export interface GetAuthorizationParams {
  authID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetAuthorizationResult =
  | GetAuthorizationOKResult
  | GetAuthorizationDefaultResult

interface GetAuthorizationOKResult {
  status: 200
  headers: Headers
  data: Authorization
}

interface GetAuthorizationDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getAuthorization = (
  params: GetAuthorizationParams,
  options: RequestOptions = {}
): Promise<GetAuthorizationResult> =>
  request(
    'GET',
    `/api/v2/authorizations/${params.authID}`,
    params,
    options
  ) as Promise<GetAuthorizationResult>

export interface PatchAuthorizationParams {
  authID: string

  data: AuthorizationUpdateRequest

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PatchAuthorizationResult =
  | PatchAuthorizationOKResult
  | PatchAuthorizationDefaultResult

interface PatchAuthorizationOKResult {
  status: 200
  headers: Headers
  data: Authorization
}

interface PatchAuthorizationDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const patchAuthorization = (
  params: PatchAuthorizationParams,
  options: RequestOptions = {}
): Promise<PatchAuthorizationResult> =>
  request(
    'PATCH',
    `/api/v2/authorizations/${params.authID}`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PatchAuthorizationResult>

export interface DeleteAuthorizationParams {
  authID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteAuthorizationResult =
  | DeleteAuthorizationNoContentResult
  | DeleteAuthorizationDefaultResult

interface DeleteAuthorizationNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteAuthorizationDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteAuthorization = (
  params: DeleteAuthorizationParams,
  options: RequestOptions = {}
): Promise<DeleteAuthorizationResult> =>
  request(
    'DELETE',
    `/api/v2/authorizations/${params.authID}`,
    params,
    options
  ) as Promise<DeleteAuthorizationResult>

export interface GetVariablesParams {
  query?: {
    org?: string
    orgID?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetVariablesResult =
  | GetVariablesOKResult
  | GetVariablesBadRequestResult
  | GetVariablesDefaultResult

interface GetVariablesOKResult {
  status: 200
  headers: Headers
  data: Variables
}

interface GetVariablesBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface GetVariablesDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getVariables = (
  params: GetVariablesParams,
  options: RequestOptions = {}
): Promise<GetVariablesResult> =>
  request('GET', '/api/v2/variables', params, options) as Promise<
    GetVariablesResult
  >

export interface PostVariableParams {
  data: Variable

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostVariableResult = PostVariableCreatedResult | PostVariableDefaultResult

interface PostVariableCreatedResult {
  status: 201
  headers: Headers
  data: Variable
}

interface PostVariableDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postVariable = (
  params: PostVariableParams,
  options: RequestOptions = {}
): Promise<PostVariableResult> =>
  request(
    'POST',
    '/api/v2/variables',
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostVariableResult>

export interface GetVariableParams {
  variableID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetVariableResult =
  | GetVariableOKResult
  | GetVariableNotFoundResult
  | GetVariableDefaultResult

interface GetVariableOKResult {
  status: 200
  headers: Headers
  data: Variable
}

interface GetVariableNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface GetVariableDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getVariable = (
  params: GetVariableParams,
  options: RequestOptions = {}
): Promise<GetVariableResult> =>
  request(
    'GET',
    `/api/v2/variables/${params.variableID}`,
    params,
    options
  ) as Promise<GetVariableResult>

export interface PutVariableParams {
  variableID: string

  data: Variable

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PutVariableResult = PutVariableOKResult | PutVariableDefaultResult

interface PutVariableOKResult {
  status: 200
  headers: Headers
  data: Variable
}

interface PutVariableDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const putVariable = (
  params: PutVariableParams,
  options: RequestOptions = {}
): Promise<PutVariableResult> =>
  request(
    'PUT',
    `/api/v2/variables/${params.variableID}`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PutVariableResult>

export interface PatchVariableParams {
  variableID: string

  data: Variable

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PatchVariableResult = PatchVariableOKResult | PatchVariableDefaultResult

interface PatchVariableOKResult {
  status: 200
  headers: Headers
  data: Variable
}

interface PatchVariableDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const patchVariable = (
  params: PatchVariableParams,
  options: RequestOptions = {}
): Promise<PatchVariableResult> =>
  request(
    'PATCH',
    `/api/v2/variables/${params.variableID}`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PatchVariableResult>

export interface DeleteVariableParams {
  variableID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteVariableResult =
  | DeleteVariableNoContentResult
  | DeleteVariableDefaultResult

interface DeleteVariableNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteVariableDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteVariable = (
  params: DeleteVariableParams,
  options: RequestOptions = {}
): Promise<DeleteVariableResult> =>
  request(
    'DELETE',
    `/api/v2/variables/${params.variableID}`,
    params,
    options
  ) as Promise<DeleteVariableResult>

export interface GetSourcesParams {
  query?: {
    org?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetSourcesResult = GetSourcesOKResult | GetSourcesDefaultResult

interface GetSourcesOKResult {
  status: 200
  headers: Headers
  data: Sources
}

interface GetSourcesDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getSources = (
  params: GetSourcesParams,
  options: RequestOptions = {}
): Promise<GetSourcesResult> =>
  request('GET', '/api/v2/sources', params, options) as Promise<
    GetSourcesResult
  >

export interface PostSourceParams {
  data: Source

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostSourceResult = PostSourceCreatedResult | PostSourceDefaultResult

interface PostSourceCreatedResult {
  status: 201
  headers: Headers
  data: Source
}

interface PostSourceDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postSource = (
  params: PostSourceParams,
  options: RequestOptions = {}
): Promise<PostSourceResult> =>
  request(
    'POST',
    '/api/v2/sources',
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostSourceResult>

export interface GetSourceParams {
  sourceID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetSourceResult =
  | GetSourceOKResult
  | GetSourceNotFoundResult
  | GetSourceDefaultResult

interface GetSourceOKResult {
  status: 200
  headers: Headers
  data: Source
}

interface GetSourceNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface GetSourceDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getSource = (
  params: GetSourceParams,
  options: RequestOptions = {}
): Promise<GetSourceResult> =>
  request(
    'GET',
    `/api/v2/sources/${params.sourceID}`,
    params,
    options
  ) as Promise<GetSourceResult>

export interface PatchSourceParams {
  sourceID: string

  data: Source

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PatchSourceResult =
  | PatchSourceOKResult
  | PatchSourceNotFoundResult
  | PatchSourceDefaultResult

interface PatchSourceOKResult {
  status: 200
  headers: Headers
  data: Source
}

interface PatchSourceNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface PatchSourceDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const patchSource = (
  params: PatchSourceParams,
  options: RequestOptions = {}
): Promise<PatchSourceResult> =>
  request(
    'PATCH',
    `/api/v2/sources/${params.sourceID}`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PatchSourceResult>

export interface DeleteSourceParams {
  sourceID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteSourceResult =
  | DeleteSourceNoContentResult
  | DeleteSourceNotFoundResult
  | DeleteSourceDefaultResult

interface DeleteSourceNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteSourceNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface DeleteSourceDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteSource = (
  params: DeleteSourceParams,
  options: RequestOptions = {}
): Promise<DeleteSourceResult> =>
  request(
    'DELETE',
    `/api/v2/sources/${params.sourceID}`,
    params,
    options
  ) as Promise<DeleteSourceResult>

export interface GetSourcesHealthParams {
  sourceID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetSourcesHealthResult =
  | GetSourcesHealthOKResult
  | GetSourcesHealthServiceUnavailableResult
  | GetSourcesHealthDefaultResult

interface GetSourcesHealthOKResult {
  status: 200
  headers: Headers
  data: HealthCheck
}

interface GetSourcesHealthServiceUnavailableResult {
  status: 503
  headers: Headers
  data: HealthCheck
}

interface GetSourcesHealthDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getSourcesHealth = (
  params: GetSourcesHealthParams,
  options: RequestOptions = {}
): Promise<GetSourcesHealthResult> =>
  request(
    'GET',
    `/api/v2/sources/${params.sourceID}/health`,
    params,
    options
  ) as Promise<GetSourcesHealthResult>

export interface GetSourcesBucketsParams {
  sourceID: string

  query?: {
    org?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetSourcesBucketsResult =
  | GetSourcesBucketsOKResult
  | GetSourcesBucketsNotFoundResult
  | GetSourcesBucketsDefaultResult

interface GetSourcesBucketsOKResult {
  status: 200
  headers: Headers
  data: Buckets
}

interface GetSourcesBucketsNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface GetSourcesBucketsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getSourcesBuckets = (
  params: GetSourcesBucketsParams,
  options: RequestOptions = {}
): Promise<GetSourcesBucketsResult> =>
  request(
    'GET',
    `/api/v2/sources/${params.sourceID}/buckets`,
    params,
    options
  ) as Promise<GetSourcesBucketsResult>

export interface GetScrapersParams {
  query?: {
    name?: string
    id?: any
    orgID?: string
    org?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetScrapersResult = GetScrapersOKResult

interface GetScrapersOKResult {
  status: 200
  headers: Headers
  data: ScraperTargetResponses
}

export const getScrapers = (
  params: GetScrapersParams,
  options: RequestOptions = {}
): Promise<GetScrapersResult> =>
  request('GET', '/api/v2/scrapers', params, options) as Promise<
    GetScrapersResult
  >

export interface PostScraperParams {
  data: ScraperTargetRequest

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostScraperResult = PostScraperCreatedResult | PostScraperDefaultResult

interface PostScraperCreatedResult {
  status: 201
  headers: Headers
  data: ScraperTargetResponse
}

interface PostScraperDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postScraper = (
  params: PostScraperParams,
  options: RequestOptions = {}
): Promise<PostScraperResult> =>
  request(
    'POST',
    '/api/v2/scrapers',
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostScraperResult>

export interface GetScraperParams {
  scraperTargetID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetScraperResult = GetScraperOKResult | GetScraperDefaultResult

interface GetScraperOKResult {
  status: 200
  headers: Headers
  data: ScraperTargetResponse
}

interface GetScraperDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getScraper = (
  params: GetScraperParams,
  options: RequestOptions = {}
): Promise<GetScraperResult> =>
  request(
    'GET',
    `/api/v2/scrapers/${params.scraperTargetID}`,
    params,
    options
  ) as Promise<GetScraperResult>

export interface PatchScraperParams {
  scraperTargetID: string

  data: ScraperTargetRequest

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PatchScraperResult = PatchScraperOKResult | PatchScraperDefaultResult

interface PatchScraperOKResult {
  status: 200
  headers: Headers
  data: ScraperTargetResponse
}

interface PatchScraperDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const patchScraper = (
  params: PatchScraperParams,
  options: RequestOptions = {}
): Promise<PatchScraperResult> =>
  request(
    'PATCH',
    `/api/v2/scrapers/${params.scraperTargetID}`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PatchScraperResult>

export interface DeleteScraperParams {
  scraperTargetID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteScraperResult =
  | DeleteScraperNoContentResult
  | DeleteScraperDefaultResult

interface DeleteScraperNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteScraperDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteScraper = (
  params: DeleteScraperParams,
  options: RequestOptions = {}
): Promise<DeleteScraperResult> =>
  request(
    'DELETE',
    `/api/v2/scrapers/${params.scraperTargetID}`,
    params,
    options
  ) as Promise<DeleteScraperResult>

export interface GetScrapersLabelsParams {
  scraperTargetID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetScrapersLabelsResult =
  | GetScrapersLabelsOKResult
  | GetScrapersLabelsDefaultResult

interface GetScrapersLabelsOKResult {
  status: 200
  headers: Headers
  data: LabelsResponse
}

interface GetScrapersLabelsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getScrapersLabels = (
  params: GetScrapersLabelsParams,
  options: RequestOptions = {}
): Promise<GetScrapersLabelsResult> =>
  request(
    'GET',
    `/api/v2/scrapers/${params.scraperTargetID}/labels`,
    params,
    options
  ) as Promise<GetScrapersLabelsResult>

export interface PostScrapersLabelParams {
  scraperTargetID: string

  data: LabelMapping

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostScrapersLabelResult =
  | PostScrapersLabelCreatedResult
  | PostScrapersLabelDefaultResult

interface PostScrapersLabelCreatedResult {
  status: 201
  headers: Headers
  data: LabelResponse
}

interface PostScrapersLabelDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postScrapersLabel = (
  params: PostScrapersLabelParams,
  options: RequestOptions = {}
): Promise<PostScrapersLabelResult> =>
  request(
    'POST',
    `/api/v2/scrapers/${params.scraperTargetID}/labels`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostScrapersLabelResult>

export interface DeleteScrapersLabelParams {
  scraperTargetID: string
  labelID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteScrapersLabelResult =
  | DeleteScrapersLabelNoContentResult
  | DeleteScrapersLabelNotFoundResult
  | DeleteScrapersLabelDefaultResult

interface DeleteScrapersLabelNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteScrapersLabelNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface DeleteScrapersLabelDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteScrapersLabel = (
  params: DeleteScrapersLabelParams,
  options: RequestOptions = {}
): Promise<DeleteScrapersLabelResult> =>
  request(
    'DELETE',
    `/api/v2/scrapers/${params.scraperTargetID}/labels/${params.labelID}`,
    params,
    options
  ) as Promise<DeleteScrapersLabelResult>

export interface GetScrapersMembersParams {
  scraperTargetID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetScrapersMembersResult =
  | GetScrapersMembersOKResult
  | GetScrapersMembersDefaultResult

interface GetScrapersMembersOKResult {
  status: 200
  headers: Headers
  data: ResourceMembers
}

interface GetScrapersMembersDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getScrapersMembers = (
  params: GetScrapersMembersParams,
  options: RequestOptions = {}
): Promise<GetScrapersMembersResult> =>
  request(
    'GET',
    `/api/v2/scrapers/${params.scraperTargetID}/members`,
    params,
    options
  ) as Promise<GetScrapersMembersResult>

export interface PostScrapersMemberParams {
  scraperTargetID: string

  data: AddResourceMemberRequestBody

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostScrapersMemberResult =
  | PostScrapersMemberCreatedResult
  | PostScrapersMemberDefaultResult

interface PostScrapersMemberCreatedResult {
  status: 201
  headers: Headers
  data: ResourceMember
}

interface PostScrapersMemberDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postScrapersMember = (
  params: PostScrapersMemberParams,
  options: RequestOptions = {}
): Promise<PostScrapersMemberResult> =>
  request(
    'POST',
    `/api/v2/scrapers/${params.scraperTargetID}/members`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostScrapersMemberResult>

export interface DeleteScrapersMemberParams {
  userID: string
  scraperTargetID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteScrapersMemberResult =
  | DeleteScrapersMemberNoContentResult
  | DeleteScrapersMemberDefaultResult

interface DeleteScrapersMemberNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteScrapersMemberDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteScrapersMember = (
  params: DeleteScrapersMemberParams,
  options: RequestOptions = {}
): Promise<DeleteScrapersMemberResult> =>
  request(
    'DELETE',
    `/api/v2/scrapers/${params.scraperTargetID}/members/${params.userID}`,
    params,
    options
  ) as Promise<DeleteScrapersMemberResult>

export interface GetScrapersOwnersParams {
  scraperTargetID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetScrapersOwnersResult =
  | GetScrapersOwnersOKResult
  | GetScrapersOwnersDefaultResult

interface GetScrapersOwnersOKResult {
  status: 200
  headers: Headers
  data: ResourceOwners
}

interface GetScrapersOwnersDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getScrapersOwners = (
  params: GetScrapersOwnersParams,
  options: RequestOptions = {}
): Promise<GetScrapersOwnersResult> =>
  request(
    'GET',
    `/api/v2/scrapers/${params.scraperTargetID}/owners`,
    params,
    options
  ) as Promise<GetScrapersOwnersResult>

export interface PostScrapersOwnerParams {
  scraperTargetID: string

  data: AddResourceMemberRequestBody

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostScrapersOwnerResult =
  | PostScrapersOwnerCreatedResult
  | PostScrapersOwnerDefaultResult

interface PostScrapersOwnerCreatedResult {
  status: 201
  headers: Headers
  data: ResourceOwner
}

interface PostScrapersOwnerDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postScrapersOwner = (
  params: PostScrapersOwnerParams,
  options: RequestOptions = {}
): Promise<PostScrapersOwnerResult> =>
  request(
    'POST',
    `/api/v2/scrapers/${params.scraperTargetID}/owners`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostScrapersOwnerResult>

export interface DeleteScrapersOwnerParams {
  userID: string
  scraperTargetID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteScrapersOwnerResult =
  | DeleteScrapersOwnerNoContentResult
  | DeleteScrapersOwnerDefaultResult

interface DeleteScrapersOwnerNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteScrapersOwnerDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteScrapersOwner = (
  params: DeleteScrapersOwnerParams,
  options: RequestOptions = {}
): Promise<DeleteScrapersOwnerResult> =>
  request(
    'DELETE',
    `/api/v2/scrapers/${params.scraperTargetID}/owners/${params.userID}`,
    params,
    options
  ) as Promise<DeleteScrapersOwnerResult>

export interface GetBackupKvParams {
  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetBackupKvResult = GetBackupKvOKResult | GetBackupKvDefaultResult

interface GetBackupKvOKResult {
  status: 200
  headers: Headers
  data: string
}

interface GetBackupKvDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getBackupKv = (
  params: GetBackupKvParams,
  options: RequestOptions = {}
): Promise<GetBackupKvResult> =>
  request('GET', '/api/v2/backup/kv', params, options) as Promise<
    GetBackupKvResult
  >

export interface GetBackupMetadataParams {
  headers?: {
    'Zap-Trace-Span'?: string
    'Accept-Encoding'?: string
  }
}

type GetBackupMetadataResult =
  | GetBackupMetadataOKResult
  | GetBackupMetadataDefaultResult

interface GetBackupMetadataOKResult {
  status: 200
  headers: Headers
  data: MetadataBackup
}

interface GetBackupMetadataDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getBackupMetadata = (
  params: GetBackupMetadataParams,
  options: RequestOptions = {}
): Promise<GetBackupMetadataResult> =>
  request('GET', '/api/v2/backup/metadata', params, options) as Promise<
    GetBackupMetadataResult
  >

export interface GetBackupShardParams {
  shardID: number

  query?: {
    since?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
    'Accept-Encoding'?: string
  }
}

type GetBackupShardResult =
  | GetBackupShardOKResult
  | GetBackupShardNotFoundResult
  | GetBackupShardDefaultResult

interface GetBackupShardOKResult {
  status: 200
  headers: Headers
  data: string
}

interface GetBackupShardNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface GetBackupShardDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getBackupShard = (
  params: GetBackupShardParams,
  options: RequestOptions = {}
): Promise<GetBackupShardResult> =>
  request(
    'GET',
    `/api/v2/backup/shards/${params.shardID}`,
    params,
    options
  ) as Promise<GetBackupShardResult>

export interface PostRestoreKvParams {
  data: string

  headers?: {
    'Zap-Trace-Span'?: string
    'Content-Encoding'?: string
    'Content-Type'?: string
  }
}

type PostRestoreKvResult =
  | PostRestoreKvOKResult
  | PostRestoreKvNoContentResult
  | PostRestoreKvDefaultResult

interface PostRestoreKvOKResult {
  status: 200
  headers: Headers
  data: {
    token?: string
  }
}

interface PostRestoreKvNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface PostRestoreKvDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postRestoreKv = (
  params: PostRestoreKvParams,
  options: RequestOptions = {}
): Promise<PostRestoreKvResult> =>
  request(
    'POST',
    '/api/v2/restore/kv',
    {...params, headers: {...params.headers, 'Content-Type': 'text/plain'}},
    options
  ) as Promise<PostRestoreKvResult>

export interface PostRestoreSqlParams {
  data: string

  headers?: {
    'Zap-Trace-Span'?: string
    'Content-Encoding'?: string
    'Content-Type'?: string
  }
}

type PostRestoreSqlResult =
  | PostRestoreSqlNoContentResult
  | PostRestoreSqlDefaultResult

interface PostRestoreSqlNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface PostRestoreSqlDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postRestoreSql = (
  params: PostRestoreSqlParams,
  options: RequestOptions = {}
): Promise<PostRestoreSqlResult> =>
  request(
    'POST',
    '/api/v2/restore/sql',
    {...params, headers: {...params.headers, 'Content-Type': 'text/plain'}},
    options
  ) as Promise<PostRestoreSqlResult>

export interface PostRestoreBucketParams {
  bucketID: string

  data: string

  headers?: {
    'Zap-Trace-Span'?: string
    'Content-Type'?: string
  }
}

type PostRestoreBucketResult =
  | PostRestoreBucketOKResult
  | PostRestoreBucketDefaultResult

interface PostRestoreBucketOKResult {
  status: 200
  headers: Headers
  data: string
}

interface PostRestoreBucketDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postRestoreBucket = (
  params: PostRestoreBucketParams,
  options: RequestOptions = {}
): Promise<PostRestoreBucketResult> =>
  request(
    'POST',
    `/api/v2/restore/bucket/${params.bucketID}`,
    {...params, headers: {...params.headers, 'Content-Type': 'text/plain'}},
    options
  ) as Promise<PostRestoreBucketResult>

export interface PostRestoreBucketMetadataParams {
  data: BucketMetadataManifest

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostRestoreBucketMetadataResult =
  | PostRestoreBucketMetadataCreatedResult
  | PostRestoreBucketMetadataDefaultResult

interface PostRestoreBucketMetadataCreatedResult {
  status: 201
  headers: Headers
  data: RestoredBucketMappings
}

interface PostRestoreBucketMetadataDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postRestoreBucketMetadata = (
  params: PostRestoreBucketMetadataParams,
  options: RequestOptions = {}
): Promise<PostRestoreBucketMetadataResult> =>
  request(
    'POST',
    '/api/v2/restore/bucketMetadata',
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostRestoreBucketMetadataResult>

export interface PostRestoreShardsParams {
  shardID: string

  data: string

  headers?: {
    'Zap-Trace-Span'?: string
    'Content-Encoding'?: string
    'Content-Type'?: string
  }
}

type PostRestoreShardsResult =
  | PostRestoreShardsNoContentResult
  | PostRestoreShardsDefaultResult

interface PostRestoreShardsNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface PostRestoreShardsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postRestoreShards = (
  params: PostRestoreShardsParams,
  options: RequestOptions = {}
): Promise<PostRestoreShardsResult> =>
  request(
    'POST',
    `/api/v2/restore/shards/${params.shardID}`,
    {...params, headers: {...params.headers, 'Content-Type': 'text/plain'}},
    options
  ) as Promise<PostRestoreShardsResult>

export interface GetConfigParams {
  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetConfigResult =
  | GetConfigOKResult
  | GetConfigUnauthorizedResult
  | GetConfigDefaultResult

interface GetConfigOKResult {
  status: 200
  headers: Headers
  data: Config
}

interface GetConfigUnauthorizedResult {
  status: 401
  headers: Headers
  data: Error
}

interface GetConfigDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getConfig = (
  params: GetConfigParams,
  options: RequestOptions = {}
): Promise<GetConfigResult> =>
  request('GET', '/api/v2/config', params, options) as Promise<GetConfigResult>

export interface GetRemotesParams {
  query: {
    orgID: string
    name?: string
    remoteURL?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetRemotesResult =
  | GetRemotesOKResult
  | GetRemotesNotFoundResult
  | GetRemotesDefaultResult

interface GetRemotesOKResult {
  status: 200
  headers: Headers
  data: RemoteConnections
}

interface GetRemotesNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface GetRemotesDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getRemotes = (
  params: GetRemotesParams,
  options: RequestOptions = {}
): Promise<GetRemotesResult> =>
  request('GET', '/api/v2/remotes', params, options) as Promise<
    GetRemotesResult
  >

export interface PostRemoteParams {
  data: RemoteConnectionCreationRequest
}

type PostRemoteResult =
  | PostRemoteCreatedResult
  | PostRemoteBadRequestResult
  | PostRemoteDefaultResult

interface PostRemoteCreatedResult {
  status: 201
  headers: Headers
  data: RemoteConnection
}

interface PostRemoteBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface PostRemoteDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postRemote = (
  params: PostRemoteParams,
  options: RequestOptions = {}
): Promise<PostRemoteResult> =>
  request(
    'POST',
    '/api/v2/remotes',
    {...params, headers: {'Content-Type': 'application/json'}},
    options
  ) as Promise<PostRemoteResult>

export interface GetRemoteParams {
  remoteID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetRemoteResult =
  | GetRemoteOKResult
  | GetRemoteNotFoundResult
  | GetRemoteDefaultResult

interface GetRemoteOKResult {
  status: 200
  headers: Headers
  data: RemoteConnection
}

interface GetRemoteNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface GetRemoteDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getRemote = (
  params: GetRemoteParams,
  options: RequestOptions = {}
): Promise<GetRemoteResult> =>
  request(
    'GET',
    `/api/v2/remotes/${params.remoteID}`,
    params,
    options
  ) as Promise<GetRemoteResult>

export interface PatchRemoteParams {
  remoteID: string

  data: RemoteConnectionUpdateRequest

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PatchRemoteResult =
  | PatchRemoteOKResult
  | PatchRemoteBadRequestResult
  | PatchRemoteNotFoundResult
  | PatchRemoteDefaultResult

interface PatchRemoteOKResult {
  status: 200
  headers: Headers
  data: RemoteConnection
}

interface PatchRemoteBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface PatchRemoteNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface PatchRemoteDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const patchRemote = (
  params: PatchRemoteParams,
  options: RequestOptions = {}
): Promise<PatchRemoteResult> =>
  request(
    'PATCH',
    `/api/v2/remotes/${params.remoteID}`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PatchRemoteResult>

export interface DeleteRemoteParams {
  remoteID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteRemoteResult =
  | DeleteRemoteNoContentResult
  | DeleteRemoteNotFoundResult
  | DeleteRemoteDefaultResult

interface DeleteRemoteNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteRemoteNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface DeleteRemoteDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteRemote = (
  params: DeleteRemoteParams,
  options: RequestOptions = {}
): Promise<DeleteRemoteResult> =>
  request(
    'DELETE',
    `/api/v2/remotes/${params.remoteID}`,
    params,
    options
  ) as Promise<DeleteRemoteResult>

export interface GetReplicationsParams {
  query: {
    orgID: string
    name?: string
    remoteID?: string
    localBucketID?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetReplicationsResult =
  | GetReplicationsOKResult
  | GetReplicationsNotFoundResult
  | GetReplicationsDefaultResult

interface GetReplicationsOKResult {
  status: 200
  headers: Headers
  data: Replications
}

interface GetReplicationsNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface GetReplicationsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getReplications = (
  params: GetReplicationsParams,
  options: RequestOptions = {}
): Promise<GetReplicationsResult> =>
  request('GET', '/api/v2/replications', params, options) as Promise<
    GetReplicationsResult
  >

export interface PostReplicationParams {
  data: ReplicationCreationRequest

  query?: {
    validate?: any
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostReplicationResult =
  | PostReplicationCreatedResult
  | PostReplicationNoContentResult
  | PostReplicationBadRequestResult
  | PostReplicationDefaultResult

interface PostReplicationCreatedResult {
  status: 201
  headers: Headers
  data: Replication
}

interface PostReplicationNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface PostReplicationBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface PostReplicationDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postReplication = (
  params: PostReplicationParams,
  options: RequestOptions = {}
): Promise<PostReplicationResult> =>
  request(
    'POST',
    '/api/v2/replications',
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostReplicationResult>

export interface GetReplicationParams {
  replicationID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetReplicationResult =
  | GetReplicationOKResult
  | GetReplicationNotFoundResult
  | GetReplicationDefaultResult

interface GetReplicationOKResult {
  status: 200
  headers: Headers
  data: Replication
}

interface GetReplicationNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface GetReplicationDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getReplication = (
  params: GetReplicationParams,
  options: RequestOptions = {}
): Promise<GetReplicationResult> =>
  request(
    'GET',
    `/api/v2/replications/${params.replicationID}`,
    params,
    options
  ) as Promise<GetReplicationResult>

export interface PatchReplicationParams {
  replicationID: string

  data: ReplicationUpdateRequest

  query?: {
    validate?: any
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PatchReplicationResult =
  | PatchReplicationOKResult
  | PatchReplicationNoContentResult
  | PatchReplicationBadRequestResult
  | PatchReplicationNotFoundResult
  | PatchReplicationDefaultResult

interface PatchReplicationOKResult {
  status: 200
  headers: Headers
  data: Replication
}

interface PatchReplicationNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface PatchReplicationBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface PatchReplicationNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface PatchReplicationDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const patchReplication = (
  params: PatchReplicationParams,
  options: RequestOptions = {}
): Promise<PatchReplicationResult> =>
  request(
    'PATCH',
    `/api/v2/replications/${params.replicationID}`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PatchReplicationResult>

export interface DeleteReplicationParams {
  replicationID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteReplicationResult =
  | DeleteReplicationNoContentResult
  | DeleteReplicationNotFoundResult
  | DeleteReplicationDefaultResult

interface DeleteReplicationNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteReplicationNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface DeleteReplicationDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteReplication = (
  params: DeleteReplicationParams,
  options: RequestOptions = {}
): Promise<DeleteReplicationResult> =>
  request(
    'DELETE',
    `/api/v2/replications/${params.replicationID}`,
    params,
    options
  ) as Promise<DeleteReplicationResult>

export interface PostReplicationsValidateParams {
  replicationID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostReplicationsValidateResult =
  | PostReplicationsValidateNoContentResult
  | PostReplicationsValidateBadRequestResult
  | PostReplicationsValidateDefaultResult

interface PostReplicationsValidateNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface PostReplicationsValidateBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface PostReplicationsValidateDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postReplicationsValidate = (
  params: PostReplicationsValidateParams,
  options: RequestOptions = {}
): Promise<PostReplicationsValidateResult> =>
  request(
    'POST',
    `/api/v2/replications/${params.replicationID}/validate`,
    params,
    options
  ) as Promise<PostReplicationsValidateResult>

export interface GetDashboardsParams {
  query?: {
    offset?: number
    limit?: number
    descending?: any
    owner?: string
    sortBy?: string
    id?: any
    orgID?: string
    org?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetDashboardsResult = GetDashboardsOKResult | GetDashboardsDefaultResult

interface GetDashboardsOKResult {
  status: 200
  headers: Headers
  data: Dashboards
}

interface GetDashboardsDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getDashboards = (
  params: GetDashboardsParams,
  options: RequestOptions = {}
): Promise<GetDashboardsResult> =>
  request('GET', '/api/v2/dashboards', params, options) as Promise<
    GetDashboardsResult
  >

export interface PostDashboardParams {
  data: CreateDashboardRequest

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostDashboardResult =
  | PostDashboardCreatedResult
  | PostDashboardDefaultResult

interface PostDashboardCreatedResult {
  status: 201
  headers: Headers
  data: Dashboard | DashboardWithViewProperties
}

interface PostDashboardDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postDashboard = (
  params: PostDashboardParams,
  options: RequestOptions = {}
): Promise<PostDashboardResult> =>
  request(
    'POST',
    '/api/v2/dashboards',
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostDashboardResult>

export interface GetTasksParams {
  query?: {
    name?: string
    after?: string
    user?: string
    org?: string
    orgID?: string
    status?: string
    limit?: number
    type?: string
  }

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetTasksResult =
  | GetTasksOKResult
  | GetTasksUnauthorizedResult
  | GetTasksInternalServerErrorResult
  | GetTasksDefaultResult

interface GetTasksOKResult {
  status: 200
  headers: Headers
  data: Tasks
}

interface GetTasksUnauthorizedResult {
  status: 401
  headers: Headers
  data: Error
}

interface GetTasksInternalServerErrorResult {
  status: 500
  headers: Headers
  data: Error
}

interface GetTasksDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getTasks = (
  params: GetTasksParams,
  options: RequestOptions = {}
): Promise<GetTasksResult> =>
  request('GET', '/api/v2/tasks', params, options) as Promise<GetTasksResult>

export interface PostTaskParams {
  data: TaskCreateRequest

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PostTaskResult =
  | PostTaskCreatedResult
  | PostTaskBadRequestResult
  | PostTaskUnauthorizedResult
  | PostTaskInternalServerErrorResult
  | PostTaskDefaultResult

interface PostTaskCreatedResult {
  status: 201
  headers: Headers
  data: Task
}

interface PostTaskBadRequestResult {
  status: 400
  headers: Headers
  data: BadRequestError
}

interface PostTaskUnauthorizedResult {
  status: 401
  headers: Headers
  data: Error
}

interface PostTaskInternalServerErrorResult {
  status: 500
  headers: Headers
  data: Error
}

interface PostTaskDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const postTask = (
  params: PostTaskParams,
  options: RequestOptions = {}
): Promise<PostTaskResult> =>
  request(
    'POST',
    '/api/v2/tasks',
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PostTaskResult>

export interface GetTaskParams {
  taskID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type GetTaskResult =
  | GetTaskOKResult
  | GetTaskBadRequestResult
  | GetTaskUnauthorizedResult
  | GetTaskNotFoundResult
  | GetTaskInternalServerErrorResult
  | GetTaskDefaultResult

interface GetTaskOKResult {
  status: 200
  headers: Headers
  data: Task
}

interface GetTaskBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface GetTaskUnauthorizedResult {
  status: 401
  headers: Headers
  data: Error
}

interface GetTaskNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface GetTaskInternalServerErrorResult {
  status: 500
  headers: Headers
  data: Error
}

interface GetTaskDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const getTask = (
  params: GetTaskParams,
  options: RequestOptions = {}
): Promise<GetTaskResult> =>
  request('GET', `/api/v2/tasks/${params.taskID}`, params, options) as Promise<
    GetTaskResult
  >

export interface PatchTaskParams {
  taskID: string

  data: TaskUpdateRequest

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type PatchTaskResult =
  | PatchTaskOKResult
  | PatchTaskBadRequestResult
  | PatchTaskUnauthorizedResult
  | PatchTaskNotFoundResult
  | PatchTaskInternalServerErrorResult
  | PatchTaskDefaultResult

interface PatchTaskOKResult {
  status: 200
  headers: Headers
  data: Task
}

interface PatchTaskBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface PatchTaskUnauthorizedResult {
  status: 401
  headers: Headers
  data: Error
}

interface PatchTaskNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface PatchTaskInternalServerErrorResult {
  status: 500
  headers: Headers
  data: Error
}

interface PatchTaskDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const patchTask = (
  params: PatchTaskParams,
  options: RequestOptions = {}
): Promise<PatchTaskResult> =>
  request(
    'PATCH',
    `/api/v2/tasks/${params.taskID}`,
    {
      ...params,
      headers: {...params.headers, 'Content-Type': 'application/json'},
    },
    options
  ) as Promise<PatchTaskResult>

export interface DeleteTaskParams {
  taskID: string

  headers?: {
    'Zap-Trace-Span'?: string
  }
}

type DeleteTaskResult =
  | DeleteTaskNoContentResult
  | DeleteTaskBadRequestResult
  | DeleteTaskUnauthorizedResult
  | DeleteTaskNotFoundResult
  | DeleteTaskInternalServerErrorResult
  | DeleteTaskDefaultResult

interface DeleteTaskNoContentResult {
  status: 204
  headers: Headers
  data: any
}

interface DeleteTaskBadRequestResult {
  status: 400
  headers: Headers
  data: Error
}

interface DeleteTaskUnauthorizedResult {
  status: 401
  headers: Headers
  data: Error
}

interface DeleteTaskNotFoundResult {
  status: 404
  headers: Headers
  data: Error
}

interface DeleteTaskInternalServerErrorResult {
  status: 500
  headers: Headers
  data: Error
}

interface DeleteTaskDefaultResult {
  status: 500
  headers: Headers
  data: Error
}

export const deleteTask = (
  params: DeleteTaskParams,
  options: RequestOptions = {}
): Promise<DeleteTaskResult> =>
  request(
    'DELETE',
    `/api/v2/tasks/${params.taskID}`,
    params,
    options
  ) as Promise<DeleteTaskResult>
